// https://vuex.vuejs.org/en/mutations.html
import { BEZERRO, ID_LEITE_VACA, MOSTRAR_PRECOS_SALVOS } from '@/utils/types.js'
import { parseString, replaceSpecialChars } from '@/utils/vuex'
import { getAcessoModulo } from '@/utils/utils'
import { LISTAR_ALIMENTOS_USUARIO, MULTIPARAS, PRIMIPARAS, SUBPRODUTOS_VOLUMOSOS } from '../utils/types'
import Animal from '@/models/Animal'
import _ from 'lodash'
import { safeParseFloat } from '../utils/utils'
import relatorioFinanceiroModelo, { relatorioFinanceiroMobile } from "@/models/relatorioFinanceiro";

export default {
  
  setCupons: (state, { cupons }) => {
    state.app.cupons = cupons
  },
  setNotificacoes: (state, notificacoes) => {
    state.app.notificacoes = notificacoes
  },
  setClientes: (state, { clientes }) => {
    state.app.consultoria.clientes = clientes
  },
  setClienteSelecionado: (state, cliente) => {
    try {
      if (cliente === null) cliente = JSON.parse(localStorage.getItem('cliente'))
    } catch (_) {
      cliente = null
    }

    state.app.consultoria.clienteSelecionado = cliente
  },
  setInfoConsultoria: (state, { info = null }) => {
    if (state.app.user.consultoria && state.app.user.consultoria !== null && info === null) info = state.app.user.consultoria
    state.app.consultoria.info = info
  },
  getDefaultConsultoria: (state) => {
    state.app.consultoria = {
      clienteSelecionado: null,
      clientes: [],
      info: {}
    }
  },
  getDefaultCliente: (state) => {
    state.app.consultoria.clienteSelecionado = null
  },
  getDefaultClientes: (state) => {
    state.app.consultoria.clientes = []
  },
  getDefaultInfoConsultoria: (state) => {
    state.app.consultoria.info = {}
  },
  setDietasAtivas: (state, dietasAtivas) => {
    state.app.dietasAtivas = dietasAtivas
  },
  getDefaultDietasAtivas: (state) => {
    state.app.dietasAtivas = null
  },
  'dietaRefinada|default': (state) => {
    state.app.dietaRefinada = {
      tipo: "MN",
      dieta: {},
    }
  },
  'dietaRefinada|setDieta': (state, dieta) => {
    state.app.dietaRefinada.dieta = dieta
  },
  'dietaRefinada|setTipo': (state, tipo = 'MN') => {
    state.app.dietaRefinada.tipo = 'MN'
  },
  setAditivos: (state, aditivos) => {
    state.app.aditivos = aditivos
  },
  setCoord: (state, coords) => {
    state.app.coords = coords
  },
  setLoading: (state, loading) => {
    state.app.loading = loading
  },
  setLinks: (state, links) => {
    state.app.links = links
  },
  setMenu: (state, val) => {
    state.app.menu1 = val
  },
  setIdioma: (state, idioma) => {
    state.app.idioma = idioma
    if (state.app.animal_) {
      state.app.animal_.idioma = idioma
      state.app.animal = state.app.animal_.getData()
    }

    localStorage.setItem('idioma', idioma)
  },
  setUser: (state, user) => {
    if (_.isNil(user)) return
    const empresa = _.get(state, 'app.empresa', null)
    state.app.acesso_premium = _.get(user, 'premium', false) || _.get(user, 'permissao', 1) === 0 || (!_.get(user, 'vinculadoEmpresaInativa', false) && _.isArray(empresa) && _.get(empresa, '[0].EXCLUIDO', 0) !== 1)
    state.app.user = _.cloneDeep(user)
  },
  setEmpresa: (state, empresa) => {
    let empresaPrincipal = _.isArray(empresa) ? _.first(empresa) : empresa
    if (_.get(empresaPrincipal, 'EXCLUIDO') === 1 && _.get(state.app.user, 'permissao') !== 0) {
      state.app.acesso_premium = false;
      state.app.empresa = null;
      state.app.consultoria = null;
      state.app.user = _.assign({}, state.app.user, {
        consultor: false,
        acesso_premium: false,
        vinculado: false,
        vinculadoEmpresaInativa: true
      })
      return;
    }
    state.app.empresa = (empresaPrincipal !== null && _.isArray(empresa)) ? empresa : (empresaPrincipal !== null) ? [empresaPrincipal] : null
  },
  setExportando: (state, exportando) => {
    state.app.exportando_dados = exportando
  },
  setVC: (state, vc) => {
    state.app.vc = vc
  },
  setFixaVC: (state, fixavc) => {
    state.app.fixavc = fixavc
  },
  setTravaBack: (state, travaBack) => {
    state.app.trava_back = travaBack
  },
  setExigenciasSelecionadas: (state, exigencias) => {
    state.app.exigencias_selecionadas = exigencias
    for (let ex of exigencias) {
      state.app.exigencias[ex].selecionado = true
    }
  },
  setTipos: (state, { tipos }) => {
    state.app.tipos = tipos
  },
  getLinks: (state) => {
    let acesso = 0
    acesso += (state.app.empresa !== null) ? 1 : 0
    acesso += (state.app.user.permissao === 0) ? 10 : 0
    let permissaoListarUsr = getAcessoModulo({ user: state.app.user, modulo: LISTAR_ALIMENTOS_USUARIO })

    if (state.app.user.permissao !== 0) {
      state.app.links = state.app.links_.filter(l => l.access <= acesso || l.to === '/seja-premium')
    } else {
      state.app.links = state.app.links_.filter(l => l.access <= acesso && l.to !== '/seja-premium')
    }
    // state.app.links[4].text = ['Alimentos', 'Feeds', 'Alimentos']
    // state.app.links[4].icon = 'mdi-corn'
    /*
      if (!permissaoListarUsr && acesso === 0 && state.app.user.permissao !== 0) {
        state.app.links[4].text = ['Enviar Alimento', 'Send Feed', 'Enviar Alimentos']
        state.app.links[4].icon = 'mdi-arrow-collapse-up'
      } else {
        state.app.links[4].text = ['Alimentos', 'Feeds', 'Alimentos']
        state.app.links[4].icon = 'mdi-corn'
    }
    */
  },
  resetStates: state => {
    // getLinks(state)
    state.app.msgState = null
    state.app.user = null
    state.app.token = null
    state.app.exigencias = null
    state.app.exigencias_selecionadas = null
    state.app.animal = null
    state.app.animal_ = null
    state.app.categorias_alimentos = null
    state.app.alimentos_selecionados = []
    state.app.composicao_racao = null
    state.app.composicao_dieta = null
    state.app.dados_predicao = null
    state.app.relatorio_financeiro = null
    state.app.excrecao = null
    state.app.vc = null
    state.app.fixavc = false
    state.app.tipo_alimento_predicao = 'MN'
    state.app.trava_back = false
    state.app.exportando = false
    state.app.dietas = []
    state.app.racoes = []
    state.app.dieta_calculada = false
    state.app.empresa = null
    state.app.acesso_premium = false
    state.app.restricoes = {
      tipoEntrada: '/MS',
      searchRestricao: null,
      indexAlimentoDialog: 0,
      pagination: {
        rowsPerPage: 20,
        sortBy: null,
        descending: false,
        page: 1,
        totalItems: 0
      },
      dialogNutrientes: false
    }
  },

  getDefaultLeiteVaca: (state) => {
    state.app.leiteDeVaca = {
      name: 'LEITE DE VACA',
      name_en: 'COW MILK',
      name_es: 'LECHE DE VACA',
      id: '0-0|0|0',
      tipo: 0,
      volumoso: false,
      alterado: false,
      custo: null,
      minimo: null,
      maximo: null,
      stored: {
        minimo: [],
        maximo: [],
        custo: [],
        quantidade: []
      },
      nutrientes: {
        'EEvD_BRCORTE2016': 0,
        'CNFvD_BRCORTE2016': 0,
        'FDNpd_BRCORTE2016': 0,
        'FDND_BRCORTE2016': 0,
        'PBvD_BRCORTE2016': 0,
        'NDT_BRCORTE2016': (0.18 / 0.1392) * 100,
        'ED_BRCORTE2016': 0,
        'EM_BRCORTE2016': 1.14 / 0.1392,
        'MM': 0,
        'CNF': 31.66,
        'EE': 38.69,
        'FDA': 0,
        'lignina': 0,
        'PB': (35.6 / 0.1392) / 10,
        'FDN': 0,
        'PDR': 0,
        'PNDR': (35.6 / 0.1392) / 10,
        'CA': (1.11 / 0.1392) / 10,
        'P': (0.76 / 0.1392) / 10,
        'S': 0.025 / 0.1392,
        'MG': (0.07 / 0.1392) / 10,
        'K': (0.7 / 0.1392) / 10,
        'NA': (0.2 / 0.1392) / 10,
        'CO': 2.29 / 0.1392,
        'CU': 1.98 / 0.1392,
        'I': 0.1 / 0.1392,
        'MN': 1.40 / 0.1392,
        'SE': 0.05 / 0.1392,
        'ZN': 35.4 / 0.1392,
        'PBA': 0,
        'PBB': 0,
        'PBKD': 0,
        'PDRPB': 0,
        'PNDRPB': 0.95 / 0.1392,
        //'PM': 30.86,
        'PM': (50.5 / 0.1392) / 10,
        'MS': 13.92,
        'EL': (0.82 / 0.1392) / 100,
        'FDNfe': 0,
        'AMIDO': 0
      },
      nutrientes_originais: {
        'EEvD_BRCORTE2016': 0,
        'CNFvD_BRCORTE2016': 0,
        'FDNpd_BRCORTE2016': 0,
        'FDND_BRCORTE2016': 0,
        'PBvD_BRCORTE2016': 0,
        'NDT_BRCORTE2016': (0.18 / 0.1392) * 100,
        'ED_BRCORTE2016': 0,
        'EM_BRCORTE2016': 1.14 / 0.1392,
        'MM': 0,
        'CNF': 31.66,
        'EE': 38.69,
        'FDA': 0,
        'lignina': 0,
        'PB': (35.6 / 0.1392) / 10,
        'FDN': 0,
        'PDR': 0,
        'PNDR': (35.6 / 0.1392) / 10,
        'CA': (1.11 / 0.1392) / 10,
        'P': (0.76 / 0.1392) / 10,
        'S': 0.025 / 0.1392,
        'MG': (0.07 / 0.1392) / 10,
        'K': (0.7 / 0.1392) / 10,
        'NA': (0.2 / 0.1392) / 10,
        'CO': 2.29 / 0.1392,
        'CU': 1.98 / 0.1392,
        'I': 0.1 / 0.1392,
        'MN': 1.40 / 0.1392,
        'SE': 0.05 / 0.1392,
        'ZN': 35.4 / 0.1392,
        'PBA': 0,
        'PBB': 0,
        'PBKD': 0,
        'PDRPB': 0,
        'PNDRPB': 0.95 / 0.1392,
        //'PM': 30.86,
        'PM': (50.5 / 0.1392) / 10,
        'MS': 13.92,
        'EL': (0.82 / 0.1392) / 100,
        'FDNfe': 0,
        'AMIDO': 0
      },
    }
    /*
    state.app.leiteDeVaca.nutrientes.NDT_BRCORTE2016 *= 100
    state.app.leiteDeVaca.nutrientes.PBKD /= 100
    state.app.leiteDeVaca.nutrientes_originais.NDT_BRCORTE2016 *= 100
    state.app.leiteDeVaca.nutrientes_originais.PBKD /= 100
    */
  },
  getDefaultExportando: (state) => {
    state.app.exportando_dados = false
  },
  getDefaultTipoAlimentoPredicao: (state) => {
    state.app.tipo_alimento_predicao = 'MN'
  },
  getDefaultVC: (state) => {
    state.app.vc = { v: null, c: null }
    state.app.fixavc = false
  },
  getDefaultFixaVC: (state) => {
    state.app.fixavc = false
  },
  getDefaultTravaBack: (state) => {
    state.app.trava_back = false
  },
  getDefaultComposicaoRacao: (state) => {
    state.app.dieta_calculada = false
    state.app.relatorio_financeiro_mobile = relatorioFinanceiroMobile
    state.app.relatorio_financeiro = relatorioFinanceiroModelo
    state.app.excrecao_mobile = {
      'excNFezes': '53.22',
      'excNUrina': '67.85',
      'excTotalN': '121.07',
      'excTotalP': '17.41',
      'producaoMetano': '154.53',
      'producaoMetanoProduto': '118.87'
    }

    state.app.excrecao = {
      excNFezes: {
        id: 'nfezes',
        title: ['Excreção de N nas Fezes', 'Fecal N', 'Excreción de N nas Fezes'],
        valor: null,
        unidade: ['g/dia', 'g/day', 'g/día']
      },
      excNUrina: {
        id: 'nurina',
        title: ['Excreção de N na Urina', 'Urinary N', 'Excreción de N na Orina'],
        valor: null,
        unidade: ['g/dia', 'g/day', 'g/día']
      },
      excTotalN: {
        id: 'ntotal',
        title: ['Excreção Total de N', 'Total N', 'Excreción Total de N'],
        valor: null,
        unidade: ['g/dia', 'g/day', 'g/día']
      },
      excTotalP: {
        id: 'ptotal',
        title: ['Excreção Total de P', 'Total P', 'Excreción Total de P'],
        valor: null,
        unidade: ['g/dia', 'g/day', 'g/día']
      },
      producaoMetano: {
        id: 'pmetano',
        title: ['Produção de Metano', 'Methane production', 'Producción de Metano'],
        valor: null,
        unidade: ['g/dia', 'g/day', 'g/día']
      },
      producaoMetanoProduto: {
        id: 'pmetanop',
        title: ['Produção de Metano por Produto', 'Methane production by product', 'Producción de Metano por Produto'],
        valor: null,
        unidade: ['g/kg', 'g/kg', 'g/kg']
      }
    }

    state.app.composicao_racao_mobile = {
      'CUSTO': {
        'alimentos': {
        },
        'title': 'Custo diário (R$/Cab.)',
        'total': '0.00',
        'exigencia': 'Custo diário (R$/Cab.)',
        'moeda': 'R$'
      },
      'MN': {
        'alimentos': {
        },
        'title': 'MN total',
        'total': '0.00',
        'exigencia': 'Total de Matéria Natural',
        'unidade': 'kg'
      },
      'MNprop': {
        'alimentos': {
        },
        'title': '%MN dieta',
        'total': '100',
        'exigencia': 'Porcentagem de Matéria Natural',
        'unidade': '%'
      },
      'MS': {
        'alimentos': {
        },
        'title': 'MS total',
        'total': '0.00',
        'exigencia': 'Total de Matéria Seca',
        'unidade': 'kg'
      },
      'MSprop': {
        'alimentos': {
        },
        'title': '%MS dieta',
        'total': '100',
        'exigencia': 'Porcentagem de Matéria Seca',
        'unidade': '%'
      },
      'MSConc': {
        'alimentos': {
        },
        'title': 'MS concentrado total',
        'total': '0.00',
        'exigencia': 'Total de Matéria Seca do Concentrado',
        'unidade': 'kg'
      },
      'MSConcProp': {
        'alimentos': {
        },
        'title': '%MS concentrado dieta',
        'total': '100',
        'exigencia': 'Porcentagem de Matéria Seca do Concentrado',
        'unidade': '%'
      },
      'totalRacao': {
        'alimentos': {
        },
        'title': 'Total de Dieta a Produzir',
        'total': 0,
        'exigencia': 'Total de Dieta a Produzir',
        'editable': true,
        'unidade': 'kg'
      },
      'proporcaoVC': {
        'title': 'Proporção V:C',
        'total': '',
        'exigencia': 'Proporção V:C',
        'unidade': '0:100'
      }
    }

    state.app.composicao_racao = {
      CUSTO: {
        id: 'custo',
        title: ['Custo Diário', 'Daily Cost', 'Costo Diario'],
        total: null,
        unidadeEsq: ['R$', '$', '$'],
        unidadeDir: ['/Cab.', '/Head', '/Cab.'],
        alimentos: {},
        ativo: false,
        exibe: true,
        usaPredicao: false
      },
      MN: {
        id: 'mn',
        title: ['Matéria Natural', 'Natural Matter', 'Materia Natural'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: true,
        usaPredicao: true
      },
      MNprop: {
        id: 'mnprop',
        title: ['%MN dieta', '%MN diet', '%MN dieta'],
        total: null,
        unidadeDir: ['%', '%', '%'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: false,
        usaPredicao: true
      },
      MS: {
        id: 'ms',
        title: ['Matéria Seca', 'Dry Matter', 'Materia Seca'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        PV: null,
        ativo: true,
        exibe: true,
        usaPredicao: true
      },
      MSprop: {
        id: 'msprop',
        title: ['%MS dieta', '%DM diet', '%MS dieta'],
        total: null,
        unidadeDir: ['%', '%', '%'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: false,
        usaPredicao: true
      },
      MSConc: {
        id: 'msConc',
        title: ['Matéria Seca do Concentrado', 'Concentrated Dry Matter', 'Concentrado de Materia Seca'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        ativo: true,
        exibe: true,
        premium: true,
        usaPredicao: true
      },
      MSConcProp: {
        id: 'msConcProp',
        title: ['%MS Concentrado Dieta', '%DM concentrate diet', '%MS Concentrado Dieta'],
        total: null,
        unidadeDir: ['%', '%', '%'],
        unidadeEsq: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: false,
        usaPredicao: true
      },
      totalRacao: {
        id: 'total',
        title: ['Total de Dieta a Produzir', 'Total Diet to Produce', 'Dieta Total a Producir'],
        total: null,
        unidadeEsq: ['', '', ''],
        unidadeDir: ['kg', 'kg', 'kg'],
        alimentos: {},
        ativo: false,
        exibe: true,
        premium: true,
        usaPredicao: true,
        editable: true
      },
      proporcaoVC: {
        id: 'propvc',
        title: ['Proporção V:C', 'F:C', 'V:C'],
        total: null,
        v: null,
        c: null,
        unidadeEsq: ['', '', ''],
        unidadeDir: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: true,
        usaPredicao: true

      },
      eficienciaAlimentar: {
        id: 'eficiencia',
        title: ['Eficiência Alimentar', 'Food Efficiency', 'Eficiencia Alimentaria'],
        total: null,
        unidadeEsq: ['', '', ''],
        unidadeDir: ['', '', ''],
        alimentos: {},
        ativo: false,
        exibe: true,
        usaPredicao: true
      }
    }

    state.app.dados_predicao_mobile = {
      GMDEsperado: null,
      PGMDEL: null,
      PGMDPM: null
    }

    state.app.dados_predicao = {
      GMDEsperado: {
        id: 'GMD.esperado',
        title: ['Ganho Médio Diário Esperado', 'Expected Daily Average Gain', 'Ganancia Media Diaria Prevista'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        oculta: false
      },
      PGMDEL: {
        id: 'PGMD.EL',
        title: ['Energia Líquida', 'Net energy', 'Energía Neta'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        oculta: false

      },
      PGMDPM: {
        id: 'PGMD.PM',
        title: ['Proteína Líquida', 'Net Protein', 'Proteína Neta'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        oculta: false
      },
      PGMDCa: {
        id: 'PGMD.Ca',
        title: ['Cálcio', 'Calcium', 'Calcio'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        oculta: true
      },
      PGMDP: {
        id: 'PGMD.P',
        title: ['Fósforo', 'Phosphorus', 'Fósforo'],
        total: null,
        unidadeDir: ['kg', 'kg', 'kg'],
        unidadeEsq: ['', '', ''],
        oculta: true
      }
    }
  },
  getDefaultComposicaoDieta: (state) => {
    state.app.composicao_dieta_mobile = {
      'CMS': {
        'exigencia': 'Matéria Seca',
        'exigencia_en': 'Dry Matter',
        'exigencia_es': 'Materia Seca',
        'id': 'MS',
        'codigo': 'MS',
        //  'codigo': 'CMS',
        'codigo_en': 'DMI',
        'codigo_es': 'MS',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '-',
        'ideal': '9.79',
        'maximo': '10.77',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'EE': {
        'exigencia': 'Extrato Etéreo',
        'exigencia_en': 'Ether extract',
        'id': 'EE',
        'codigo_en': 'EE',
        'codigo': 'EE',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '-',
        'ideal': '-',
        'maximo': '0.69',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'CNF': {
        'exigencia': 'Carboidratos Não Fibrosos',
        'exigencia_en': 'Non-fiber carbohydrates',
        'id': 'CNF',
        'codigo': 'CNF',
        'codigo_en': 'NFC',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '-',
        'ideal': '-',
        'maximo': '7.83',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'FDN': {
        'exigencia': 'Fibra em Detergente Neutro',
        'exigencia_en': 'Neutral detergent fiber',
        'id': 'FDN',
        'codigo': 'FDN',
        'codigo_en': 'NDF',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '2.45',
        'ideal': '-',
        'maximo': '6.20',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'FDNfe': {
        'exigencia': 'Fibra em Detergente Neutro Fisicamente Efetiva',
        'exigencia_en': 'Physically Effective Neutral Detergent Fiber',
        'id': 'FDNfe',
        'codigo': 'FDNfe',
        'codigo_en': 'peNDF',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '2.45',
        'ideal': '-',
        'maximo': '6.20',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'NDT': {
        'exigencia': 'Exigências Totais de NDT',
        'exigencia_en': 'Total TDN requirements',
        'id': 'NDT_BRCORTE2016',
        'codigo': 'NDT',
        'codigo_en': 'TDN',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '6.56',
        'ideal': '6.56',
        'maximo': '6.88',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'EL': {
        'exigencia': 'Energia Líquida',
        'exigencia_en': 'Net energy requirements',
        'id': 'EL',
        'codigo': 'EL',
        'codigo_en': 'NE',
        'unidade': 'Mcal/dia',
        'unidade_en': 'Mcal/day',
        'minimo': '13.72',
        'ideal': '13.72',
        'maximo': '14.40',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {

        }
      },
      'EM': {
        'exigencia': 'Energia Metabolizável',
        'exigencia_en': 'Metabolizable energy requirements',
        'id': 'EM_BRCORTE2016',
        'codigo': 'EM',
        'codigo_en': 'ME',
        'unidade': 'Mcal/dia',
        'unidade_en': 'Mcal/day',
        'minimo': '24.30',
        'ideal': '24.30',
        'maximo': '25.52',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'PDR': {
        'exigencia': 'Proteína Degradada no Rúmen',
        'exigencia_en': 'Rumen degradable protein requirements',
        'id': 'PDR',
        'codigo': 'PDR',
        'codigo_en': 'RDP',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '729.96',
        'ideal': '729.96',
        'maximo': '839.45',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        },
        'fixed': '729.96'
      },
      'PNDR': {
        'exigencia': 'Proteína Não Degradada no Rúmen',
        'exigencia_en': 'Rumen undegradable protein requirements',
        'id': 'PNDR',
        'codigo': 'PNDR',
        'codigo_en': 'RUP',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '327.40',
        'ideal': '327.40',
        'maximo': '360.14',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'PB': {
        'exigencia': 'Proteína Bruta',
        'exigencia_en': 'Crude protein requirements',
        'id': 'PB',
        'codigo': 'PB',
        'codigo_en': 'CP',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '1057.36',
        'ideal': '1057.36',
        'maximo': '1163.09',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'PM': {
        'exigencia': 'Proteína Metabolizável',
        'exigencia_en': 'Metabolizable protein requirements',
        'id': 'PM',
        'codigo': 'PM',
        'codigo_en': 'MPt',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '729.09',
        'ideal': '729.09',
        'maximo': '802.00',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'AMIDO': {
        'exigencia': 'Teor de Amido',
        'exigencia_en': 'Starch Content',
        'id': 'AMIDO',
        'codigo': 'AMIDO',
        'codigo_en': 'STARCH',
        'unidade': 'kg/dia',
        'unidade_en': 'kg/day',
        'minimo': '2.45',
        'ideal': '-',
        'maximo': '6.20',
        'editable': 'ideal',
        'fator': 0.01,
        'alimentos': {
        }
      },
      'Ca': {
        'exigencia': 'Exigências dietéticas de Cálcio',
        'exigencia_en': 'Dietary requirements of calcium',
        'id': 'CA',
        'codigo': 'Ca',
        'codigo_en': 'tCa',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '25.67',
        'ideal': '25.67',
        'maximo': '51.34',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'P': {
        'exigencia': 'Exigências dietéticas de Fósforo',
        'exigencia_en': 'Dietary requirements of phosphorus',
        'id': 'P',
        'codigo': 'P',
        'codigo_en': 'tP',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '17.51',
        'ideal': '17.51',
        'maximo': '35.03',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'Mg': {
        'exigencia': 'Exigências dietéticas de Magnésio',
        'exigencia_en': 'Dietary requirements of magnesium',
        'id': 'MG',
        'codigo': 'Mg',
        'codigo_en': 'tMg',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '9.11',
        'ideal': '9.11',
        'maximo': '27.34',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'K': {
        'exigencia': 'Exigências dietéticas de Potássio',
        'exigencia_en': 'Dietary requirements of potassium',
        'id': 'K',
        'codigo': 'K',
        'codigo_en': 'tMg',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '27.88',
        'ideal': '27.88',
        'maximo': '83.63',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'Na': {
        'exigencia': 'Exigências dietéticas de Sódio',
        'exigencia_en': 'Dietary requirements of sodium',
        'id': 'NA',
        'codigo': 'Na',
        'codigo_en': 'tNa',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '11.08',
        'ideal': '11.08',
        'maximo': '66.49',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'S': {
        'exigencia': 'Exigências dietéticas de Enxofre',
        'exigencia_en': 'Dietary requirements of sulfur',
        'id': 'S',
        'codigo': 'S',
        'codigo_en': 'S',
        'unidade': 'g/dia',
        'unidade_en': 'g/day',
        'minimo': '16.47',
        'ideal': '16.47',
        'maximo': '49.40',
        'editable': 'ideal',
        'fator': 10,
        'alimentos': {
        }
      },
      'Co': {
        'exigencia': 'Exigências dietéticas de Cobalto',
        'exigencia_en': 'Dietary requirements of cobalt',
        'id': 'CO',
        'codigo': 'Co',
        'codigo_en': 'Co',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '7.37',
        'ideal': '7.37',
        'maximo': '147.32',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'Cu': {
        'exigencia': 'Exigências dietéticas de Cobre',
        'exigencia_en': 'Dietary requirements of copper',
        'id': 'CU',
        'codigo': 'Cu',
        'codigo_en': 'Cu',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '76.51',
        'ideal': '76.51',
        'maximo': '229.53',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'I': {
        'exigencia': 'Exigências dietéticas de Iodo',
        'exigencia_en': 'Dietary requirements of iodine',
        'id': 'I',
        'codigo': 'I',
        'codigo_en': 'I',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '4.90',
        'ideal': '4.90',
        'maximo': '97.93',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'Mn': {
        'exigencia': 'Exigências dietéticas de Manganês',
        'exigencia_en': 'Dietary requirements of manganese',
        'id': 'MN',
        'codigo': 'Mn',
        'codigo_en': 'Mn',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '222.23',
        'ideal': '222.23',
        'maximo': '666.68',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'Se': {
        'exigencia': 'Exigências dietéticas de Selênio',
        'exigencia_en': 'Dietary requirements of selenium',
        'id': 'SE',
        'codigo': 'Se',
        'codigo_en': 'Se',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '5.39',
        'ideal': '5.39',
        'maximo': '107.74',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      },
      'Zn': {
        'exigencia': 'Exigências dietéticas de Zinco',
        'exigencia_en': 'Dietary requirements of zinc',
        'id': 'ZN',
        'codigo': 'Zn',
        'codigo_en': 'Zn',
        'unidade': 'mg/dia',
        'unidade_en': 'mg/day',
        'minimo': '614.29',
        'ideal': '614.29',
        'maximo': '1842.88',
        'editable': 'ideal',
        'fator': 1,
        'alimentos': {
        }
      }
    }
    state.app.composicao_dieta = {}
    for (let exigencia in state.app.exigencias) {
      state.app.composicao_dieta[exigencia] = {
        id: exigencia,
        alimentos: {}

      }
    }
  },
  getDefaultAlimentos: (state) => {
    state.app.alimentos_checked_mobile = []
    state.app.restricoes_mobile = {}
    const alimentosStored = JSON.parse(localStorage.getItem('alimentosStored'))
    state.app.categorias_alimentos.forEach(el => {
      el.volumoso = el.id === 0 || el.id === 7 || el.id === 6 || el.id === 1
      el.derivados.forEach((elem) => {
        for (let nutrienteVal of Object.values(state.app.ingredientesCompletos)) {
          let nutriente = nutrienteVal.id
          
          elem.nutrientes[nutriente] = elem.nutrientes_originais[nutriente] ? elem.nutrientes_originais[nutriente] : '0.00'
        }

        elem.voltou_original = false
        elem.minimo = elem.maximo = elem.custo = elem.quantidade = null
        elem.alterado = false
        elem.volumoso = elem.tipo === 0 || elem.tipo === 7 || elem.tipo === 6 || elem.tipo === 1 || SUBPRODUTOS_VOLUMOSOS.includes(elem.id)
        elem.stored = (alimentosStored !== null) ? (alimentosStored[elem.id] && alimentosStored[elem.id].stored) ? alimentosStored[elem.id].stored : {} : {}
      })
    })
  },
  getDefaultAnimal: (state) => {
    state.app.restricoes = {
      tipoEntrada: '/MS',
      searchRestricao: null,
      indexAlimentoDialog: 0,
      pagination: {
        rowsPerPage: 20,
        sortBy: null,
        descending: false,
        page: 1,
        totalItems: 0
      },
      dialogNutrientes: false
    }
    state.app.alimentos_selecionados = []
    state.app.animal_mobile = {
      'menu': 'FormulacaoDieta',
      'peso_corporal_inicial': '400',
      'peso_corporal_final': '540',
      'peso_corporal_medio': '',
      'ganho_medio_diario': '1.3',
      'total_racao_a_produzir': '1000',
      'tipo': 'crescimento_terminacao',
      'raca': 'zebuino',
      'regime': 'confinamento',
      'sexo': 'macho',
      'numero_animais': '',
      'custo_mao_de_obra': '',
      'custo_energia': '',
      'custo_maquinario': '',
      'custo_medicamentos': '',
      'custo_extra': '33',
      'preco_venda_arroba': '190',
      'preco_arroba_adquirida': '160',
      'rendimento_carcaca_inicial': '50',
      'rendimento_carcaca_final': '53',
      'taxa_juros_mensal': '1',
      'estado_fisiologico': '',
      'escore_corporal': 5,
      'producao_de_leite': 0,
      'semana_lactacao': 1,
      'proteina_do_leite': 3.56,
      'gordura_do_leite': 4.76,
      'lactose_do_leite': 4.56,
      'peso_bezerro_nascimento': 32,
      'dias_gestacao': 210,
      'refresh_input': false
    }
    state.app.tipo = 'FD'
    state.app.animal_ = new Animal(state)
    state.app.animal = state.app.animal_.getData()
  },
  getDefaultAnimalExigencias: (state) => {
    state.app.restricoes = {
      tipoEntrada: '/MS',
      searchRestricao: null,
      indexAlimentoDialog: 0,
      pagination: {
        rowsPerPage: 20,
        sortBy: null,
        descending: false,
        page: 1,
        totalItems: 0
      },
      dialogNutrientes: false
    }
    state.app.alimentos_selecionados = []
    state.app.animal_mobile = {
      'menu': 'Exigencias',
      'peso_corporal_inicial': '400',
      'peso_corporal_final': '540',
      'peso_corporal_medio': '',
      'ganho_medio_diario': '1.3',
      'total_racao_a_produzir': '1000',
      'tipo': 'crescimento_terminacao',
      'raca': 'zebuino',
      'regime': 'confinamento',
      'sexo': 'macho',
      'numero_animais': '',
      'custo_mao_de_obra': '',
      'custo_energia': '',
      'custo_maquinario': '',
      'custo_medicamentos': '',
      'custo_extra': '33',
      'preco_venda_arroba': '190',
      'preco_arroba_adquirida': '160',
      'rendimento_carcaca_inicial': '50',
      'rendimento_carcaca_final': '53',
      'taxa_juros_mensal': '1',
      'estado_fisiologico': '',
      'escore_corporal': 5,
      'producao_de_leite': 7,
      'semana_lactacao': 1,
      'proteina_do_leite': 3.56,
      'gordura_do_leite': 4.76,
      'lactose_do_leite': 4.56,
      'peso_bezerro_nascimento': 32,
      'dias_gestacao': 210,
      'refresh_input': false
    }
    state.app.tipo = 'E'
    state.app.animal_ = new Animal(state)
    state.app.animal = state.app.animal_.getData()
  },
  getDefaultAnimalPredicao: (state) => {
    state.app.alimentos_selecionados = []
    state.app.animal_mobile = {
      'menu': 'Predicao',
      'peso_corporal_inicial': '',
      'peso_corporal_final': '',
      'peso_corporal_medio': '',
      'ganho_medio_diario': '',
      'total_racao_a_produzir': 1000,
      'tipo': 'crescimento_terminacao',
      'raca': 'zebuino',
      'regime': 'confinamento',
      'sexo': 'macho',
      'numero_animais': '',
      'custo_mao_de_obra': '',
      'custo_energia': '',
      'custo_maquinario': '',
      'custo_medicamentos': '',
      'custo_extra': '33',
      'preco_venda_arroba': '190',
      'preco_arroba_adquirida': '160',
      'rendimento_carcaca_inicial': '50',
      'rendimento_carcaca_final': '53',
      'taxa_juros_mensal': '1',
      'estado_fisiologico': '',
      'escore_corporal': 5,
      'producao_de_leite': 7,
      'semana_lactacao': 1,
      'proteina_do_leite': 3.56,
      'gordura_do_leite': 4.76,
      'lactose_do_leite': 4.56,
      'peso_bezerro_nascimento': 32,
      'dias_gestacao': 210,
      'refresh_input': false
    }
    state.app.tipo = 'PD'
    state.app.animal_ = new Animal(state)
    state.app.animal = state.app.animal_.getData()
  },
  getDefaultExigencias: (state) => {
    state.app.exigencias_selecionadas = new Set()
    state.app.exigencias_selecionadas.add('CMS')
    state.app.exigencias = {
      'CMS': {
        'exigencia': ['Matéria Seca', 'Dry matter', 'Materia seca'],
        'id': 'MS',
        'codigo': ['MS', 'DM', 'MS'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': true,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'disabled': true
      },
      'EE': {
        'exigencia': ['Extrato Etéreo', 'Ether extract', 'Extrato Etéreo'],
        'id': 'EE',
        'codigo': ['EE', 'EE', 'EE'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'maxEditable': false,
        'fator': 0.01,
        'selecionado': false,
        'minEditable': false
      },
      'CNF': {
        'exigencia': ['Carboidratos Não Fibrosos', 'Non-fiber carbohydrates', 'Carbohidratos sin fibra'],
        'id': 'CNF',
        'codigo': ['CNF', 'NFC', 'CSF'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false
      },
      'FDN': {
        'exigencia': ['Fibra em Detergente Neutro', 'Neutral detergent fiber', 'Fibra detergente neutra'],
        'id': 'FDN',
        'codigo': ['FDN', 'NDF', 'FDN'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'divider': true
      },
      'NDT': {
        'exigencia': ['Exigências Totais de NDT', 'Total TDN requirements', 'Exigencias Totales de NDT'],
        'id': 'NDT_BRCORTE2016',
        'codigo': ['NDT', 'TDN', 'NDT'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['EL', 'EM'],
        'childs': {
          'PCJ': {
            'codigo': ['PCJ', 'SBW', 'APV'],
            'name': ['Peso Vivo em Jejum', 'Shrunk body weight', 'Ayuno de peso vivo'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PCVZ': {
            'codigo': ['PCVZ', 'EBW', 'PCVZ'],
            'name': ['Peso de Corpo Vazio', 'Empty body weight', 'Peso del cuerpo vacío'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'GPCVZ': {
            'codigo': ['GPCVZ', 'EBWG', 'APCVZ'],
            'name': ['Ganho de Peso de Corpo Vazio', 'Empty body weight gain', 'Aumento de peso del cuerpo vacío'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PCVZeq': {
            'codigo': ['PCVZeq', 'EQEBW', 'PCVZeq'],
            'name': ['Peso de Corpo Vazio equivalente', 'Equivalent empty body weight', 'Peso corporal vacío equivalente'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }
        }
      },
      'EL': {
        'exigencia': ['Energia Líquida', 'Net energy requirements', 'Energía Neta'],
        'id': 'EL',
        'codigo': ['EL', 'NE', 'EN'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,
        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['NDT', 'EM'],
        'childs': {
          'ELm': {
            'codigo': ['ELm', 'NEm', 'ENm'],
            'name': ['Energia Líquida (Mantença)', 'Net energy requirements for maintenance', 'Energía Neta (Mantenimiento)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'ELg': {
            'codigo': ['ELg', 'NEg', 'ENg'],
            'name': ['Energia Líquida (Ganho)', 'Net energy requirements for gain', 'Energía Neta (Ganancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'ELl': {
            'codigo': ['ELl', 'ELl', 'ENl'],
            'name': ['Energia Líquida (Lactação)', 'Net energy requirements for lactation', 'Energía Neta (Lactancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'ERP': {
            'codigo': ['ERP', 'REp', 'ERP'],
            'name': ['Energia Retida como Proteína', 'Net energy retained in the form of protein', 'Energía retenida como proteína'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'km': {
            'codigo': ['km', 'km', 'km'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Mantença', 'Metabolizable energy efficiency for maintenance', 'Eficiencia de Uso de Energía Metabolizable para Mantenimiento'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'kg': {
            'codigo': ['kg', 'kg', 'kg'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Ganho', 'Metabolizable energy efficiency for weight gain', 'Eficiencia del uso de energía metabolizable para ganancia'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PL': {
            'codigo': ['PL', 'NP', 'PL'],
            'name': ['Produção de Leite', 'Milk yield', 'Producción de leche'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'PLCG': {
            'codigo': ['PLCG', 'FCM', 'PLCG'],
            'name': ['Produção de Leite (corrigida para gordura)', '4 percent fat corrected milk', 'Leche con 4 por ciento de grasa corregida'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'EM': {
        'exigencia': ['Energia Metabolizável', 'Metabolizable energy requirements', 'Energía Metabolizable'],
        'id': 'EM_BRCORTE2016',
        'codigo': ['EM', 'ME', 'EM'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['EL', 'NDT'],
        'childs': {
          'EMm': {
            'codigo': ['EMm', 'MEm', 'EMm'],
            'name': ['Energia Metabolizável (Mantença)', 'Metabolizable energy requirements for maintenance', 'Energía Metabolizable (Mantenimiento)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'EMg': {
            'codigo': ['EMg', 'MEg', 'EMg'],
            'name': ['Energia Metabolizável (Ganho)', 'Metabolizable energy requirements for gain', 'Energía Metabolizable (Ganancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'EMl': {
            'codigo': ['EMl', 'MEl', 'EMl'],
            'name': ['Energia Metabolizável (Lactação)', 'Metabolizable energy requirements for lactation', 'Energía Metabolizable (Lactancia)'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'ED': {
            'codigo': ['ED', 'DE', 'ED'],
            'name': ['Energia Digestível', 'Digestible energy requirements', 'Energía digerible'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }

        }
      },
      'PDR': {
        'exigencia': ['Proteína Degradada no Rúmen', 'Rumen degradable protein requirements', 'Proteína degradada en el rumen'],
        'id': 'PDR',
        'codigo': ['PDR', 'RDP', 'PDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PNDR': {
        'exigencia': ['Proteína Não Degradada no Rúmen', 'Rumen undegradable protein requirements', 'Proteína no degradada en el rumen'],
        'id': 'PNDR',
        'codigo': ['PNDR', 'RUP', 'PNDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PB': {
        'exigencia': ['Proteína Bruta', 'Crude protein requirements', 'Proteína cruda'],
        'id': 'PB',
        'codigo': ['PB', 'CP', 'PC'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['PM'],
        'childs': {
          'PL': {
            'codigo': ['PL', 'NP', 'PN'],
            'name': ['Proteína Líquida', 'Net protein requirements', 'Proteína Neta'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PLg': {
            'codigo': ['PLg', 'NPg', 'PNg'],
            'name': ['Proteína Líquida (Ganho)', 'Net protein requirements (Gain)', 'Proteína neta (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'k': {
            'codigo': ['EPM', 'EPM', 'EPM'],
            'name': ['Eficiência de Utilização de Proteína Metabolizável para Ganho', 'Metabolizable protein efficiency for weight gain', 'Eficiencia de la proteína metabolizable para el aumento de peso'],
            'unidade': ['%', '%', '%'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }

        }
      },
      'PM': {
        'exigencia': ['Proteína Metabolizável', 'Metabolizable protein requirements', 'Proteína metabolizable'],
        'id': 'PM',
        'codigo': ['PM', 'MPt', 'PM'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['PB'],
        'childs': {
          'PMm': {
            'codigo': ['PMm', 'MPm', 'PMm'],
            'name': ['Proteína Metabolizável (Mantença)', 'Metabolizable protein requirements for maintenance', 'Proteína Metabolizable (Mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PMg': {
            'codigo': ['PMg', 'MPg', 'PMg'],
            'name': ['Proteína Metabolizável (Ganho)', 'Metabolizable protein requirements for weight gain', 'Proteína Metabolizable (Ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'PMl': {
            'codigo': ['PMl', 'lCa', 'PMl'],
            'name': ['Proteína Metabolizável (Lactação)', 'Metabolizable protein requirements for lactation', 'Proteína Metabolizable (Lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          },
          'PBmic': {
            'codigo': ['PBmic', 'MCP', 'PBmic'],
            'name': ['Produção de Proteína Bruta Microbiana', 'Microbial crude protein synthesis', 'Producción de proteína cruda microbiana'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          }
        }

      },
      'Ca': {
        'exigencia': ['Exigências dietéticas de Cálcio', 'Dietary requirements of calcium', 'Requerimientos dietéticos de calcio'],
        'id': 'CA',
        'codigo': ['Ca', 'tCa', 'Ca'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Cam': {
            'codigo': ['Cam', 'mCa', 'Cam'],
            'name': ['Exigências dietéticas de Cálcio (Mantença)', 'Dietary requirements of calcium for maintenance', 'Requerimientos dietéticos de calcio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Cag': {
            'codigo': ['Cag', 'gCa', 'Cag'],
            'name': ['Exigências dietéticas de Cálcio (Ganho)', 'Dietary requirements of calcium for weight gain', 'Requerimientos dietéticos de calcio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Cal': {
            'codigo': ['Cal', 'lCa', 'Cal'],
            'name': ['Exigências dietéticas de Cálcio (Lactação)', 'Dietary requirements of calcium for lactation', 'Requerimientos dietéticos de calcio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'P': {
        'exigencia': ['Exigências dietéticas de Fósforo', 'Total dietary requirements of phosphorus', 'Requerimientos dietéticos de fósforo'],
        'id': 'P',
        'codigo': ['P', 'tP', 'P'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Pm': {
            'codigo': ['Pm', 'mP', 'Pm'],
            'name': ['Exigências dietéticas de Fósforo (Mantença)', 'Dietary requirements of phosphorus for maintenance', 'Requerimientos dietéticos de fósforo (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Pg': {
            'codigo': ['Pg', 'gP', 'Pg'],
            'name': ['Exigências dietéticas de Fósforo (Ganho)', 'Dietary requirements of phosphorus for weight gain', 'Requerimientos dietéticos de fósforo (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Pl': {
            'codigo': ['Pl', 'lP', 'Pl'],
            'name': ['Exigências dietéticas de Fósforo (Lactação)', 'Dietary requirements of phosphorus for lactation', 'Requerimientos dietéticos de fósforo (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'Mg': {
        'exigencia': ['Exigências dietéticas de Magnésio', 'Dietary requirements of magnesium', 'Requerimientos dietéticos de magnesio'],
        'id': 'MG',
        'codigo': ['Mg', 'tMg', 'Mg'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Mgm': {
            'codigo': ['Mgm', 'mMg', 'Mgm'],
            'name': ['Exigências dietéticas de Magnésio (Mantença)', 'Dietary requirements of magnesium for maintenance', 'Requisitos dietéticos para el magnesio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Mgg': {
            'codigo': ['Mgg', 'gMg', 'Mgg'],
            'name': ['Exigências dietéticas de Magnésio (Ganho)', 'Dietary requirements of magnesium for weight gain', 'Requerimientos dietéticos de magnesio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Mgl': {
            'codigo': ['Mgl', 'lMg', 'Mgl'],
            'name': ['Exigências dietéticas de Magnésio (Lactação)', 'Dietary requirements of magnesium for lactation', 'Requerimientos dietéticos de magnesio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'K': {
        'exigencia': ['Exigências dietéticas de Potássio', 'Dietary requirements of potassium', 'Requerimientos dietéticos de potasio'],
        'id': 'K',
        'codigo': ['K', 'K', 'K'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'KM': {
            'codigo': ['KM', 'mK', 'KM'],
            'name': ['Exigências dietéticas de Potássio (Mantença)', 'Dietary requirements of potassium for maintenance', 'Requerimientos dietéticos de potasio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Kg': {
            'codigo': ['Kg', 'gK', 'Kg'],
            'name': ['Exigências dietéticas de Potássio (Ganho)', 'Dietary requirements of potassium for weight gain', 'Requerimientos dietéticos de potasio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Kl': {
            'codigo': ['Kl', 'lK', 'Kl'],
            'name': ['Exigências dietéticas de Potássio (Lactação)', 'Dietary requirements of potassium for lactation', 'Requerimientos dietéticos de potasio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }
      },
      'Na': {
        'exigencia': ['Exigências dietéticas de Sódio', 'Dietary requirements of sodium', 'Requerimientos dietéticos de sodio'],
        'id': 'NA',
        'codigo': ['Na', 'Na', 'Na'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Nam': {
            'codigo': ['Nam', 'mNa', 'Nam'],
            'name': ['Exigências dietéticas de Sódio (Mantença)', 'Dietary requirements of sodium for maintenance', 'Requisitos dietéticos de sodio (mantenimiento)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Nag': {
            'codigo': ['Nag', 'gNa', 'Nag'],
            'name': ['Exigências dietéticas de Sódio (Ganho)', 'Dietary requirements of sodium for weight gain', 'Requerimientos dietéticos de sodio (ganancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null
          },
          'Nal': {
            'codigo': ['Nal', 'lNa', 'Nal'],
            'name': ['Exigências dietéticas de Sódio (Lactação)', 'Dietary requirements of sodium for lactation', 'Requerimientos dietéticos de sodio (lactancia)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': null,
            'ideal': null,
            'maximo': null,
            'lactante': true
          }
        }

      },
      'S': {
        'exigencia': ['Exigências dietéticas de Enxofre', 'Dietary requirements of sulfur', 'Requerimientos dietéticos de azufre'],
        'id': 'S',
        'codigo': ['S', 'S', 'S'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false
      },
      'Co': {
        'exigencia': ['Exigências dietéticas de Cobalto', 'Dietary requirements of cobalt', 'Requerimientos dietéticos del cobalto'],
        'id': 'CO',
        'codigo': ['Co', 'Co', 'Co'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Cu': {
        'exigencia': ['Exigências dietéticas de Cobre', 'Dietary requirements of copper', 'Requerimientos dietéticos de cobre'],
        'id': 'CU',
        'codigo': ['Cu', 'Cu', 'Cu'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'I': {
        'exigencia': ['Exigências dietéticas de Iodo', 'Dietary requirements of iodine', 'Requerimientos dietéticos de yodo'],
        'id': 'I',
        'codigo': ['I', 'I', 'I'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Mn': {
        'exigencia': ['Exigências dietéticas de Manganês', 'Dietary requirements of manganese', 'Requerimientos dietéticos de manganeso'],
        'id': 'MN',
        'codigo': ['Mn', 'Mn', 'Mn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Se': {
        'exigencia': ['Exigências dietéticas de Selênio', 'Dietary requirements of selenium', 'Requerimientos dietéticos del selenio'],
        'id': 'SE',
        'codigo': ['Se', 'Se', 'Se'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Zn': {
        'exigencia': ['Exigências dietéticas de Zinco', 'Dietary requirements of zinc', 'Requerimientos dietéticos de zinc'],
        'id': 'ZN',
        'codigo': ['Zn', 'Zn', 'Zn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': null,
        'ideal': null,
        'maximo': null,
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      }
    }
    state.app.exigencias_resultados = {
      'CMS': {
        'exigencia': ['Matéria Seca', 'Dry matter', 'Materia seca'],
        'id': 'MS',
        'codigo': ['MS', 'DM', 'MS'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'fator': 0.01,
        'selecionado': true,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'disabled': true
      },
      'EE': {
        'exigencia': ['Extrato Etéreo', 'Ether extract', 'Extrato Etéreo'],
        'id': 'EE',
        'codigo': ['EE', 'EE', 'EE'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'maxEditable': false,
        'fator': 0.01,
        'selecionado': false,
        'minEditable': false
      },
      'CNF': {
        'exigencia': ['Carboidratos Não Fibrosos', 'Non-fiber carbohydrates', 'Carbohidratos sin fibra'],
        'id': 'CNF',
        'codigo': ['CNF', 'NFC', 'CSF'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false
      },
      'FDN': {
        'exigencia': ['Fibra em Detergente Neutro', 'Neutral detergent fiber', 'Fibra detergente neutra'],
        'id': 'FDN',
        'codigo': ['FDN', 'NDF', 'FDN'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'divider': true
      },
      'FDNfe': {
        'exigencia': ['Fibra em Detergente Neutro Fisicamente Efetiva', 'Physically Effective Neutral Detergent Fiber', 'Fibra detergente neutra físicamente eficaz'],
        'id': 'FDNfe',
        'codigo': ['FDNfe', 'peNDF', 'FDNfe'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'minimo_raw': 0.00,
        'ideal_raw': 0.00,
        'maximo_raw': 0.00,
        'minimo_calc': 0.00,
        'ideal_calc': 0.00,
        'maximo_calc': 0.00,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'apenasCalcula': true,
        'divider': true
      },
      'AMIDO': {
        'exigencia': ['Teor de Amido', 'Starch Content', 'Contenido de Almidón'],
        'id': 'AMIDO',
        'codigo': ['AMIDO', 'STARCH', 'ALMIDÓN'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'minimo_raw': 0.00,
        'ideal_raw': 0.00,
        'maximo_raw': 0.00,
        'minimo_calc': 0.00,
        'ideal_calc': 0.00,
        'maximo_calc': 0.00,
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'apenasCalcula': true,
        'divider': true
      },
      'NDT': {
        'exigencia': ['Exigências Totais de NDT', 'Total TDN requirements', 'Exigencias Totales de NDT'],
        'id': 'NDT_BRCORTE2016',
        'codigo': ['NDT', 'TDN', 'NDT'],
        'unidade': ['kg/dia', 'kg/day', 'kg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'fator': 0.01,
        'selecionado': false,
        'idealEditable': true,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['EL', 'EM'],
        'childs': {
          'PCJ': {
            'codigo': ['PCJ', 'SBW'],
            'name': ['Peso Vivo em Jejum', 'Shrunk body weight'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PCVZ': {
            'codigo': ['PCVZ', 'EBW'],
            'name': ['Peso de Corpo Vazio', 'Empty body weight'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'GPCVZ': {
            'codigo': ['GPCVZ', 'EBWG'],
            'name': ['Ganho de Peso de Corpo Vazio', 'Empty body weight gain'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PCVZeq': {
            'codigo': ['PCVZeq', 'EQEBW'],
            'name': ['Peso de Corpo Vazio equivalente', 'Equivalent empty body weight'],
            'unidade': ['kg', 'kg', 'kg'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          }
        }
      },
      'EL': {
        'exigencia': ['Energia Líquida', 'Net energy requirements', 'Energía Neta'],
        'id': 'EL',
        'codigo': ['EL', 'NE', 'EN'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,
        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['NDT', 'EM'],
        'childs': {
          'ELm': {
            'codigo': ['ELm', 'NEm'],
            'name': ['Energia Líquida (Mantença)', 'Net energy requirements for maintenance'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'ELg': {
            'codigo': ['ELg', 'NEg'],
            'name': ['Energia Líquida (Ganho)', 'Net energy requirements for gain'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'ELl': {
            'codigo': ['ELl', 'ELl'],
            'name': ['Energia Líquida (Lactação)', 'Net energy requirements for lactation'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          },
          'ERP': {
            'codigo': ['ERP', 'REp'],
            'name': ['Energia Retida como Proteína', 'Net energy retained in the form of protein'],
            'unidade': ['%', '%', '%'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'km': {
            'codigo': ['km', 'km'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Mantença', 'Metabolizable energy efficiency for maintenance'],
            'unidade': ['%', '%', '%'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'kg': {
            'codigo': ['kg', 'kg', 'kg'],
            'name': ['Eficiência de Utilização de Energia Metabolizável para Ganho', 'Metabolizable energy efficiency for weight gain'],
            'unidade': ['%', '%', '%'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PL': {
            'codigo': ['PL', 'NP'],
            'name': ['Produção de Leite', 'Milk yield'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          },
          'PLCG': {
            'codigo': ['PLCG', 'FCM'],
            'name': ['Produção de Leite (corrigida para gordura)', '4 percent fat corrected milk'],
            'unidade': ['kg/dia', 'kg/day', 'kg/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }
      },
      'EM': {
        'exigencia': ['Energia Metabolizável', 'Metabolizable energy requirements', 'Energía Metabolizable'],
        'id': 'EM_BRCORTE2016',
        'codigo': ['EM', 'ME', 'EM'],
        'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['EL', 'NDT'],
        'childs': {
          'EMm': {
            'codigo': ['EMm', 'MEm'],
            'name': ['Energia Metabolizável (Mantença)', 'Metabolizable energy requirements for maintenance'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'EMg': {
            'codigo': ['EMg', 'MEg'],
            'name': ['Energia Metabolizável (Ganho)', 'Metabolizable energy requirements for gain'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'EMl': {
            'codigo': ['EMl', 'MEl'],
            'name': ['Energia Metabolizável (Lactação)', 'Metabolizable energy requirements for lactation'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          },
          'ED': {
            'codigo': ['ED', 'DE'],
            'name': ['Energia Digestível', 'Digestible energy requirements'],
            'unidade': ['Mcal/dia', 'Mcal/day', 'Mcal/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          }

        }
      },
      'PDR': {
        'exigencia': ['Proteína Degradada no Rúmen', 'Rumen degradable protein requirements', 'Proteína degradada en el rumen'],
        'id': 'PDR',
        'codigo': ['PDR', 'RDP', 'PDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PNDR': {
        'exigencia': ['Proteína Não Degradada no Rúmen', 'Rumen undegradable protein requirements', 'Proteína no degradada en el rumen'],
        'id': 'PNDR',
        'codigo': ['PNDR', 'RUP', 'PNDR'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'maxEditable': false,
        'minEditable': false
      },
      'PB': {
        'exigencia': ['Proteína Bruta', 'Crude protein requirements', 'Proteína cruda'],
        'id': 'PB',
        'codigo': ['PB', 'CP', 'PC'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'radio': true,
        'otherOptions': ['PM'],
        'childs': {
          'PL': {
            'codigo': ['PL', 'NP'],
            'name': ['Proteína Líquida', 'Net protein requirements'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PLg': {
            'codigo': ['PLg', 'NPg'],
            'name': ['Proteína Líquida (Ganho)', 'Net protein requirements (Gain)'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'k': {
            'codigo': ['EPM', 'EPM'],
            'name': ['Eficiência de Utilização de Proteína Metabolizável para Ganho', 'Metabolizable protein efficiency for weight gain'],
            'unidade': ['%', '%', '%'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          }

        }
      },
      'PM': {
        'exigencia': ['Proteína Metabolizável', 'Metabolizable protein requirements', 'Proteína metabolizable'],
        'id': 'PM',
        'codigo': ['PM', 'MPt', 'PM'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'divider': true,
        'radio': true,
        'otherOptions': ['PB'],
        'childs': {
          'PMm': {
            'codigo': ['PMm', 'MPm'],
            'name': ['Proteína Metabolizável (Mantença)', 'Metabolizable protein requirements for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PMg': {
            'codigo': ['PMg', 'MPg'],
            'name': ['Proteína Metabolizável (Ganho)', 'Metabolizable protein requirements for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'PMl': {
            'codigo': ['PMl', 'lCa'],
            'name': ['Proteína Metabolizável (Lactação)', 'Metabolizable protein requirements for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          },
          'PBmic': {
            'codigo': ['PBmic', 'MCP'],
            'name': ['Produção de Proteína Bruta Microbiana', 'Microbial crude protein synthesis'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          }
        }

      },
      'Ca': {
        'exigencia': ['Exigências dietéticas de Cálcio', 'Dietary requirements of calcium', 'Requerimientos dietéticos de calcio'],
        'id': 'CA',
        'codigo': ['Ca', 'tCa', 'Ca'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Cam': {
            'codigo': ['Cam', 'mCa'],
            'name': ['Exigências dietéticas de Cálcio (Mantença)', 'Dietary requirements of calcium for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Cag': {
            'codigo': ['Cag', 'gCa'],
            'name': ['Exigências dietéticas de Cálcio (Ganho)', 'Dietary requirements of calcium for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Cal': {
            'codigo': ['Cal', 'lCa'],
            'name': ['Exigências dietéticas de Cálcio (Lactação)', 'Dietary requirements of calcium for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }
      },
      'P': {
        'exigencia': ['Exigências dietéticas de Fósforo', 'Total dietary requirements of phosphorus', 'Requerimientos dietéticos de fósforo'],
        'id': 'P',
        'codigo': ['P', 'tP', 'P'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Pm': {
            'codigo': ['Pm', 'mP'],
            'name': ['Exigências dietéticas de Fósforo (Mantença)', 'Dietary requirements of phosphorus for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Pg': {
            'codigo': ['Pg', 'gP'],
            'name': ['Exigências dietéticas de Fósforo (Ganho)', 'Dietary requirements of phosphorus for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Pl': {
            'codigo': ['Pl', 'lP'],
            'name': ['Exigências dietéticas de Fósforo (Lactação)', 'Dietary requirements of phosphorus for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }
      },
      'Mg': {
        'exigencia': ['Exigências dietéticas de Magnésio', 'Dietary requirements of magnesium', 'Requerimientos dietéticos de magnesio'],
        'id': 'MG',
        'codigo': ['Mg', 'tMg', 'Mg'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Mgm': {
            'codigo': ['Mgm', 'mMg'],
            'name': ['Exigências dietéticas de Magnésio (Mantença)', 'Dietary requirements of magnesium for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Mgg': {
            'codigo': ['Mgg', 'gMg'],
            'name': ['Exigências dietéticas de Magnésio (Ganho)', 'Dietary requirements of magnesium for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Mgl': {
            'codigo': ['Mgl', 'lMg'],
            'name': ['Exigências dietéticas de Magnésio (Lactação)', 'Dietary requirements of magnesium for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }
      },
      'K': {
        'exigencia': ['Exigências dietéticas de Potássio', 'Dietary requirements of potassium', 'Requerimientos dietéticos de potasio'],
        'id': 'K',
        'codigo': ['K', 'K', 'K'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'KM': {
            'codigo': ['KM', 'mK'],
            'name': ['Exigências dietéticas de Potássio (Mantença)', 'Dietary requirements of potassium for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Kg': {
            'codigo': ['Kg', 'gK'],
            'name': ['Exigências dietéticas de Potássio (Ganho)', 'Dietary requirements of potassium for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Kl': {
            'codigo': ['Kl', 'lK'],
            'name': ['Exigências dietéticas de Potássio (Lactação)', 'Dietary requirements of potassium for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }
      },
      'Na': {
        'exigencia': ['Exigências dietéticas de Sódio', 'Dietary requirements of sodium', 'Requerimientos dietéticos de sodio'],
        'id': 'NA',
        'codigo': ['Na', 'Na', 'Na'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false,
        'childs': {
          'Nam': {
            'codigo': ['Nam', 'mNa'],
            'name': ['Exigências dietéticas de Sódio (Mantença)', 'Dietary requirements of sodium for maintenance'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Nag': {
            'codigo': ['Nag', 'gNa'],
            'name': ['Exigências dietéticas de Sódio (Ganho)', 'Dietary requirements of sodium for weight gain'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00'
          },
          'Nal': {
            'codigo': ['Nal', 'lNa'],
            'name': ['Exigências dietéticas de Sódio (Lactação)', 'Dietary requirements of sodium for lactation'],
            'unidade': ['g/dia', 'g/day', 'g/día'],
            'minimo': '0,00',
            'ideal': '0,00',
            'maximo': '0,00',
            'lactante': true
          }
        }

      },
      'S': {
        'exigencia': ['Exigências dietéticas de Enxofre', 'Dietary requirements of sulfur', 'Requerimientos dietéticos de azufre'],
        'id': 'S',
        'codigo': ['S', 'S', 'S'],
        'unidade': ['g/dia', 'g/day', 'g/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 10,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': false
      },
      'Co': {
        'exigencia': ['Exigências dietéticas de Cobalto', 'Dietary requirements of cobalt', 'Requerimientos dietéticos del cobalto'],
        'id': 'CO',
        'codigo': ['Co', 'Co', 'Co'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Cu': {
        'exigencia': ['Exigências dietéticas de Cobre', 'Dietary requirements of copper', 'Requerimientos dietéticos de cobre'],
        'id': 'CU',
        'codigo': ['Cu', 'Cu', 'Cu'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'I': {
        'exigencia': ['Exigências dietéticas de Iodo', 'Dietary requirements of iodine', 'Requerimientos dietéticos de yodo'],
        'id': 'I',
        'codigo': ['I', 'I', 'I'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Mn': {
        'exigencia': ['Exigências dietéticas de Manganês', 'Dietary requirements of manganese', 'Requerimientos dietéticos de manganeso'],
        'id': 'MN',
        'codigo': ['Mn', 'Mn', 'Mn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Se': {
        'exigencia': ['Exigências dietéticas de Selênio', 'Dietary requirements of selenium', 'Requerimientos dietéticos del selenio'],
        'id': 'SE',
        'codigo': ['Se', 'Se', 'Se'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      },
      'Zn': {
        'exigencia': ['Exigências dietéticas de Zinco', 'Dietary requirements of zinc', 'Requerimientos dietéticos de zinc'],
        'id': 'ZN',
        'codigo': ['Zn', 'Zn', 'Zn'],
        'unidade': ['mg/dia', 'mg/day', 'mg/día'],
        'minimo': '0,00',
        'ideal': '0,00',
        'maximo': '0,00',
        'idealEditable': true,
        'fator': 1,

        'selecionado': false,
        'minEditable': false,
        'maxEditable': false,
        'micromineral': true
      }
    }
  },
  setExigencias: (state, newValue) => {
    state.app.exigencias = newValue
  },
  setTipoAlimentoPredicao: (state, newValue) => {
    state.app.tipo_alimento_predicao = newValue
  },
  setPredicao: (state, newValue) => {
    state.app.dados_predicao = newValue
    for (let item in newValue) {
      state.app.dados_predicao_mobile[item] = newValue[item]['total']
    }
  },
  setTipoAnimal: (state, newValue) => {
    state.app.animal = newValue
    state.app.animal_ = new Animal(state, newValue)
    for (let item in newValue) {
      state.app.animal_mobile[item] = state.app.animal_.__data[item].valor
    }
  },
  setAlimentosUsuario: (state, { alimentos }) => {
    const temPermissaoPremium = getAcessoModulo({ user: state.app.user, modulo: MOSTRAR_PRECOS_SALVOS })
    alimentos = Object.values(alimentos)
    if (alimentos === null || alimentos.length === 0) return
    // if (!state.app.acesso_premium) return
    let cliente = localStorage.getItem('cliente')
    let clienteID = null
    if (cliente !== null) {
      cliente = JSON.parse(cliente)
      clienteID = parseInt(cliente.id)
    }
    if (clienteID !== null) {
      alimentos = alimentos.filter(a => a.id_cliente === null || a.id_cliente === clienteID)
    }
    alimentos = alimentos.filter(a => a.nutrientes && a.id_empresa === null)
    var alimentosProcess = []
    let alimentosStored = JSON.parse(localStorage.getItem('alimentosStored'))
    let namesPT = {}
    let permissaoListarUsr = getAcessoModulo({ user: state.app.user, modulo: LISTAR_ALIMENTOS_USUARIO })

    alimentos.forEach((el, index) => {
      el.nome = el.nome === null ? '' : el.nome
      el.nome_espanhol = el.nome_espanhol === null ? '' : el.nome_espanhol
      el.nome_ingles = el.nome_ingles === null ? '' : el.nome_ingles

      let id = 'USR' + '|' + el.id
      let name = '' + el.nome.toUpperCase()
      let nameEn = '' + ((el.nome_ingles === null) ? el.nome.toUpperCase() : el.nome_ingles.toUpperCase())
      let nameEs = '' + ((el.nome_espanhol === null) ? el.nome.toUpperCase() : el.nome_espanhol.toUpperCase())
      if (namesPT[name] !== undefined) name += ' ' + id
      namesPT[name] = name
      let nameSci = el.alimento_cientifico
      let tipoName = el.id_tipo
      // ----------------------------
      // corrige casas decimais do NDT e PBKD
      // el.nutrientes.NDT_BRCORTE2016 *= 100
      // el.nutrientes.PBKD /= 100
      // -------------------------
      el.nutrientes_raw = {}
      if (typeof (el.nutrientes) === 'string') {
        el.nutrientes = JSON.parse(el.nutrientes)
        el.nutrientes_raw = Object.assign({}, el.nutrientes)
      }

      for (let ingrediente in state.app.ingredientesCompletos) {
        let nutriente = ingrediente
        if (el.nutrientes[nutriente] === undefined || el.nutrientes[nutriente] === '' || el.nutrientes[nutriente] === null) {
          el.nutrientes[nutriente] = 0
        }
        if (typeof el.nutrientes[nutriente] === 'string' && el.nutrientes[nutriente].indexOf(',') !== -1) {
          el.nutrientes[nutriente] = el.nutrientes[nutriente].replace(',', '.')
        }
        el.nutrientes_raw[nutriente] = parseFloat(parseFloat(el.nutrientes[nutriente]).toFixed(2))
        el.nutrientes[nutriente] = parseFloat(el.nutrientes[nutriente]).toFixed(2)
      }

      el.volumoso = el.id === ID_LEITE_VACA || el.id_tipo === 0 || el.id_tipo === 7 || el.id_tipo === 6 || el.id_tipo === 1 || SUBPRODUTOS_VOLUMOSOS.includes(el.id)
      const milhoSilagemFdni = 22.49
      el.nutrientes_raw['MO'] = 100 - el.nutrientes_raw['MM']
      el.nutrientes['MO'] = parseFloat(el.nutrientes_raw['MO']).toFixed(2)

      if (el.nutrientes_raw.EE && el.nutrientes_raw.EE > 0 && ([undefined, '', 0, null].includes(el.nutrientes_raw.EEvD_BRCORTE2016) || el.nutrientes_raw.EEvD_BRCORTE2016 < 0)) {
        el.nutrientes_raw.EEvD_BRCORTE2016 = 0.86 * el.nutrientes_raw.EE
        el.nutrientes.EEvD_BRCORTE2016 = parseFloat(el.nutrientes.EEvD_BRCORTE2016).toFixed(2)
      }
      // Corrige CNFvD
      if (el.nutrientes_raw.CNF && el.nutrientes_raw.CNF > 0 && [undefined, '', 0, null].includes(el.nutrientes_raw.CNFvD_BRCORTE2016)) {
        el.nutrientes_raw.CNFvD_BRCORTE2016 = 0.95 * el.nutrientes_raw.CNF
        el.nutrientes.CNFvD_BRCORTE2016 = parseFloat(el.nutrientes_raw.CNFvD_BRCORTE2016).toFixed(2)
      }
      
      // Corrige PBvD
      if ([undefined, '', 0, null].includes(el.nutrientes_raw.PBvD_BRCORTE2016) || el.nutrientes_raw.PBvD_BRCORTE2016 < 0) {
        if (el.nutrientes_raw.PB && el.nutrientes_raw.PB > 0) {
          el.nutrientes_raw.PBvD_BRCORTE2016 = el.nutrientes_raw.PB * 0.95
          el.nutrientes.PBvD_BRCORTE2016 = parseFloat(el.nutrientes_raw.PBvD_BRCORTE2016).toFixed(2)
        }
      }

      // Corrige FDND
      if ([undefined, '', 0, null].includes(el.nutrientes_raw.FDND_BRCORTE2016 ) || el.nutrientes_raw.FDND_BRCORTE2016  < 0) {
          el.nutrientes_raw.FDND_BRCORTE2016  = safeParseFloat(el.nutrientes.FDND_BRCORTE2016);
      }

      // calculo de ED e EM;
      el.nutrientes['ED_BRCORTE2016'] = el.nutrientes['ED_BRCORTE2016'] && el.nutrientes['ED_BRCORTE2016'] > 0 ? el.nutrientes['ED_BRCORTE2016'] : ((el.nutrientes['NDT_BRCORTE2016'] * 4.409) / 100)
      el.nutrientes['EM_BRCORTE2016'] = el.nutrientes['EM_BRCORTE2016'] && el.nutrientes['EM_BRCORTE2016'] > 0 ? el.nutrientes['EM_BRCORTE2016'] : (el.nutrientes['ED_BRCORTE2016'] - 0.9455)
      el.nutrientes['ED_BRCORTE2016'] = parseFloat(el.nutrientes['ED_BRCORTE2016']).toFixed(2)
      el.nutrientes['EM_BRCORTE2016'] = parseFloat(el.nutrientes['EM_BRCORTE2016']).toFixed(2)
      el.nutrientes_raw['ED_BRCORTE2016'] = parseFloat(el.nutrientes['ED_BRCORTE2016'])
      el.nutrientes_raw['EM_BRCORTE2016'] = parseFloat(el.nutrientes['EM_BRCORTE2016'])
      
      alimentosProcess.push({
        id: id,
        tipo: el.id_tipo,
        tipo_name: tipoName,
        name: name,
        name_en: nameEn,
        name_es: nameEs,
        name_sci: nameSci,
        voltou_original: false,
        nutrientes: {},
        nutrientes_originais: {},
        nutrientes_raw: {},
        restrito: el.restrito,
        alterado: false,
        custo: null,
        quantidade: null,
        unidade: 'kg',
        minimo: null,
        maximo: null,
        listar: false,
        id_alimento_pai: el.id_alimento_pai,
        id_cliente: el.id_cliente ? el.id_cliente : null,
        id_pessoa: el.id_pessoa ? el.id_pessoa : null,
        id_empresa: el.id_empresa ? el.id_empresa : null,
        cliente: el.cliente,
        custo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].custo_salvo,
        maximo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].maximo_salvo,
        minimo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].minimo_salvo,
        stored: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? {} : alimentosStored[id].stored,
        volumoso: el.id === ID_LEITE_VACA || el.id_tipo === 0 || el.id_tipo === 7 || el.id_tipo === 6 || el.id_tipo === 1 || SUBPRODUTOS_VOLUMOSOS.includes(id),
        EXCLUIDO: (!permissaoListarUsr) ? 1 : (el.EXCLUIDO === undefined) ? 0 : el.EXCLUIDO
      })

      Object.assign(alimentosProcess[index].nutrientes_raw, el.nutrientes_raw)
      Object.assign(alimentosProcess[index].nutrientes, el.nutrientes)
      Object.assign(alimentosProcess[index].nutrientes_originais, el.nutrientes)
    })
    let categorias = state.app.categorias_alimentos
    let alimentosUsr = alimentosProcess.filter(a => a.EXCLUIDO !== 1).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0)
    if (categorias && categorias !== null && categorias.filter(c => c.id === 999).length === 0 && alimentosUsr.length > 0) {
      categorias.push({
        id: 999,
        idOrd: 999,
        name: 'ALIMENTOS USUÁRIO',
        name_en: 'USER FEEDS',
        name_es: 'ALIMENTOS DEL USUARIO',
        derivados: alimentosUsr,
        oculto: alimentosUsr.length === 0 || !permissaoListarUsr
      })
    }
    let alimentosOcultos = alimentosProcess.filter(a => a.EXCLUIDO && a.EXCLUIDO === 1)
    if (categorias.filter(c => c.id === 10001).length !== 0) {
      categorias = categorias.filter(c => c.id !== 10001)
    }
    if (categorias && categorias !== null && categorias.filter(c => c.id === 10001).length === 0 && alimentosOcultos.length > 0) {
      categorias.push({
        id: 10001,
        idOrd: 10001,
        name: 'OCULTO - usr',
        name_en: '',
        derivados: alimentosOcultos,
        oculto: true
      })
    }
    categorias = categorias.sort(function (a, b) {
      if (a.idOrd > b.idOrd) {
        return 1
      }
      if (a.idOrd < b.idOrd) {
        return -1
      }
      // a must be equal to b
      return 0
    })
    state.app.categorias_alimentos = categorias
  },
  setAlimentosEmpresa: (state, { alimentos }) => {
    const temPermissaoPremium = getAcessoModulo({ user: state.app.user, modulo: MOSTRAR_PRECOS_SALVOS })

    alimentos = Object.values(alimentos)
    alimentos = alimentos.filter(a => a.nutrientes && a.nutrientes !== null)
    if (alimentos === null || alimentos.length === 0) return
    var alimentosProcess = []
    let alimentosStored = JSON.parse(localStorage.getItem('alimentosStored'))
    let namesPT = {}
    alimentos.forEach((el, index) => {
      el.nome = el.nome === null ? '' : el.nome
      el.nome_espanhol = el.nome_espanhol === null ? '' : el.nome_espanhol
      el.nome_ingles = el.nome_ingles === null ? '' : el.nome_ingles
      let id = 'EMP' + '|' + el.id
      let name = (el.empresa ? '' + el.empresa.nome.toUpperCase() + ' - ' : '') + el.nome.toUpperCase()
      let nameEn = (el.empresa ? '' + el.empresa.nome.toUpperCase() + ' - ' : '') + ((el.nome_ingles === null) ? el.nome.toUpperCase() : el.nome_ingles.toUpperCase())
      let nameEs = (el.empresa ? '' + el.empresa.nome.toUpperCase() + ' - ' : '') + ((el.nome_espanhol === null) ? el.nome.toUpperCase() : el.nome_espanhol.toUpperCase())
      if (namesPT[name] !== undefined) name += ' ' + id
      namesPT[name] = name
      let nameSci = el.alimento_cientifico
      let tipoName = el.id_tipo
      // ----------------------------
      // corrige casas decimais do NDT e PBKD
      // el.nutrientes.NDT_BRCORTE2016 *= 100
      // el.nutrientes.PBKD /= 100
      // -------------------------
      el.nutrientes_raw = {}
      if (typeof (el.nutrientes) === 'string') {
        el.nutrientes = JSON.parse(el.nutrientes)
        el.nutrientes_raw = Object.assign({}, el.nutrientes)
      }
      for (let ingrediente in state.app.ingredientesCompletos) {
        let nutriente = ingrediente
        if (el.nutrientes[nutriente] === undefined || el.nutrientes[nutriente] === '' || el.nutrientes[nutriente] === null) {
          el.nutrientes[nutriente] = 0
        }
        el.nutrientes_raw[nutriente] = parseFloat(el.nutrientes[nutriente])
        el.nutrientes[nutriente] = parseFloat(el.nutrientes[nutriente]).toFixed(2)
      }
      el.nutrientes['ED_BRCORTE2016'] = el.nutrientes['ED_BRCORTE2016'] && el.nutrientes['ED_BRCORTE2016'] > 0 ? el.nutrientes['ED_BRCORTE2016'] : ((el.nutrientes['NDT_BRCORTE2016'] * 4.409) / 100)
      el.nutrientes['EM_BRCORTE2016'] = el.nutrientes['EM_BRCORTE2016'] && el.nutrientes['EM_BRCORTE2016'] > 0 ? el.nutrientes['EM_BRCORTE2016'] : (el.nutrientes['ED_BRCORTE2016'] - 0.9455)
      el.nutrientes['ED_BRCORTE2016'] = parseFloat(el.nutrientes['ED_BRCORTE2016']).toFixed(2)
      el.nutrientes['EM_BRCORTE2016'] = parseFloat(el.nutrientes['EM_BRCORTE2016']).toFixed(2)
      el.nutrientes_raw['ED_BRCORTE2016'] = parseFloat(el.nutrientes['ED_BRCORTE2016'])
      el.nutrientes_raw['EM_BRCORTE2016'] = parseFloat(el.nutrientes['EM_BRCORTE2016'])
      alimentosProcess.push({
        id: id,
        tipo: el.id_tipo,
        tipo_name: tipoName,
        name: name,
        name_en: nameEn,
        name_es: nameEs,
        name_sci: nameSci,
        voltou_original: false,
        nutrientes: {},
        nutrientes_originais: {},
        nutrientes_raw: {},
        restrito: (state.app.user && state.app.user.emp_user && el.empresa.id === state.app.user.emp_user.id_empresa && state.app.user.emp_user.acesso === 0) ? false : el.restrito,
        alterado: false,
        custo: null,
        quantidade: null,
        unidade: 'kg',
        minimo: null,
        maximo: null,
        listar: false,
        min_100: el.min_100,
        max_100: el.max_100,
        patrocinado: el.patrocinado === 1,
        empresa: el.empresa,
        id_alimento_pai: el.id_alimento_pai,
        id_cliente: el.id_cliente ? el.id_cliente : null,
        id_pessoa: el.id_pessoa ? el.id_pessoa : null,
        id_empresa: el.id_empresa ? el.id_empresa : null,
        custo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].custo_salvo,
        maximo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].maximo_salvo,
        minimo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].minimo_salvo,
        stored: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? {} : alimentosStored[id].stored,
        volumoso: el.id === ID_LEITE_VACA || el.id_tipo === 0 || el.id_tipo === 7 || el.id_tipo === 6 || el.id_tipo === 1 || SUBPRODUTOS_VOLUMOSOS.includes(id),
        EXCLUIDO: (el.EXCLUIDO === undefined) ? 0 : el.EXCLUIDO
      })

      Object.assign(alimentosProcess[index].nutrientes_raw, el.nutrientes_raw)
      Object.assign(alimentosProcess[index].nutrientes, el.nutrientes)
      Object.assign(alimentosProcess[index].nutrientes_originais, el.nutrientes)
    })

    let categorias = state.app.categorias_alimentos
    for (let i in categorias) {
      let el = Object.assign({}, categorias[i])
      let als = alimentosProcess.filter(elem => ((el.id === 8) || el.id !== 8) && elem.tipo === el['id']).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0).filter((a) => (state.app.user.premium) ? false : (a.patrocinado && (a.EXCLUIDO === undefined || a.EXCLUIDO !== 1)))
      if (als === null || als.length === 0) continue
      let aux = []
      let alsInc = 0
      for (let alI in el['derivados'].filter(a => !a['id'].startsWith('EMP|'))) {
        if (alI % 3 === 0 && als.length > alsInc) {
          if (als[alsInc].patrocinado && als[alsInc].EXCLUIDO !== 1) {
            aux.push(als[alsInc++])
          } else {
            alsInc++
          }
        }
        aux.push(el['derivados'][alI])
      }
      for (let a in als) {
        if (a < alsInc) continue
        if (als[a].patrocinado) {
          aux.push(als[a])
        }
      }
      categorias[i]['derivados'] = aux
    }

    let alimentosEmpresa = alimentosProcess.filter(a => (state.app.user.premium) ? (a.EXCLUIDO !== 1) : ((a.EXCLUIDO !== 1))).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0)
    if (categorias.filter(c => c.id === 998).length === 0 && alimentosEmpresa.length > 0) {
      categorias.push({
        id: 998,
        idOrd: 998,
        name: 'PRODUTOS',
        name_en: 'COMPANY FEEDS',
        name_es: 'PRODUCTOS',
        derivados: alimentosEmpresa,
        oculto: alimentosEmpresa.length === 0
      })
    }
    let alimentosOcultos = alimentosProcess.filter(a => a.EXCLUIDO === 1)
    if (categorias.filter(c => c.id === 10000).length !== 0) {
      categorias = categorias.filter(c => c.id !== 10000)
    }
    if (categorias.filter(c => c.id === 10000).length === 0 && alimentosOcultos.length > 0) {
      categorias.push({
        id: 10000,
        idOrd: 10000,
        name: 'OCULTO - EMPRESA',
        name_en: '',
        derivados: alimentosOcultos,
        oculto: true
      })
    }
    categorias = categorias.sort(function (a, b) {
      if (a.idOrd > b.idOrd) {
        return 1
      }
      if (a.idOrd < b.idOrd) {
        return -1
      }
      // a must be equal to b
      return 0
    })
    state.app.categorias_alimentos = categorias
  },
  setAlimentos: (state, { tipos, alimentos }) => {
    const temPermissaoPremium = getAcessoModulo({ user: state.app.user, modulo: MOSTRAR_PRECOS_SALVOS })
    alimentos = Object.values(alimentos)
    alimentos.sort((a, b) => {
      return +(replaceSpecialChars(a.derivado) > replaceSpecialChars(b.derivado)) || -(replaceSpecialChars(a.derivado) < replaceSpecialChars(b.derivado))
    })
    var alimentosProcess = []
    let alimentosStored = JSON.parse(localStorage.getItem('alimentosStored'))
    let namesPT = {}

    alimentos.forEach((el, index) => {
      let id = el.id_derivado + '-' + parseInt(el.id_agrupamento) + '|' + parseInt(el.ini) + '|' + String(el.fim).replace('.', '_')
      if (el.fim === '05' || el.fim === '0.5' || el.fim === '0_5') {
        el.fim = '0.5'.replace('.', state.app.strings[state.app.idioma].separador_float)
      }
      let name = el.id_agrupamento !== 52 ? el.derivado.toUpperCase() + ' (' + el.ini + '-' + el.fim + ' ' + el.agrupamento + ')' : el.derivado.toUpperCase()
      let nameEn = ''
      if (el.derivado_en !== '' && el.derivado_en !== ' ') {
        nameEn = el.id_agrupamento !== 52 ? el.derivado_en.toUpperCase() + ' (' + el.ini + '-' + el.fim + ' ' + el.agrupamento_en + ')' : el.derivado_en.toUpperCase()
      } else {
        nameEn = name
      }
      let nameEs = ''
      if (el.derivado_es !== '' && el.derivado_es !== ' ') {
        nameEs = el.id_agrupamento !== 52 ? el.derivado_es.toUpperCase() + ' (' + el.ini + '-' + el.fim + ' ' + el.agrupamento_en + ')' : el.derivado_es.toUpperCase()
      } else {
        nameEs = name
      }

      //AB#4720
      if(nameEs === 'MAÍZ MAÍZ') {
        nameEs = 'HARINA DE MAÍZ'
      }

      if (namesPT[name] !== undefined) name += ' ' + id
      namesPT[name] = name
      let nameSci = el.alimento_cientifico
      let tipoName = el.tipo
      // ----------------------------
      // corrige casas decimais do NDT e PBKD
      // el.nutrientes.NDT_BRCORTE2016 *= 100
      // el.nutrientes.PBKD /= 100
      // -------------------------

      // corrige NDT AB#5316
      if(el.nutrientes.NDT_BRCORTE2016 < 1) {
        el.nutrientes.NDT_BRCORTE2016 *= 100
      }

      // corrige PBKD AB#5326
      if(el.nutrientes.PBKD > 1) {
        el.nutrientes.PBKD /= 100
      }

      el.nutrientes_raw = {}
      for (let nutriente in el.nutrientes) {
        el.nutrientes_raw[nutriente] = el.nutrientes[nutriente]
        el.nutrientes[nutriente] = el.nutrientes[nutriente].toFixed(2)
      }
      alimentosProcess.push({
        id: id,
        tipo: el.id_tipo,
        tipo_name: tipoName,
        name: name,
        name_en: nameEn,
        name_es: nameEs,
        name_sci: nameSci,
        voltou_original: false,
        nutrientes: {},
        nutrientes_originais: {},
        nutrientes_raw: {},
        restrito: false,
        alterado: false,
        custo: null,
        id_pessoa: el.id_pessoa ? el.id_pessoa : null,
        id_empresa: el.id_empresa ? el.id_empresa : null,
        id_cliente: el.id_cliente ? el.id_cliente : null,
        quantidade: null,
        unidade: 'kg',
        minimo: null,
        maximo: null,
        listar: false,
        custo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].custo_salvo,
        maximo_salvo: (!temPermissaoPremium ||alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].maximo_salvo,
        minimo_salvo: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? undefined : alimentosStored[id].minimo_salvo,
        stored: (!temPermissaoPremium || alimentosStored === null || alimentosStored === {} || alimentosStored[id] === undefined) ? {} : alimentosStored[id].stored,
        volumoso: el.id === ID_LEITE_VACA || el.id_tipo === 0 || el.id_tipo === 7 || el.id_tipo === 6 || el.id_tipo === 1 || SUBPRODUTOS_VOLUMOSOS.includes(id),
        EXCLUIDO: (el.EXCLUIDO === undefined) ? 0 : el.EXCLUIDO
      })

      Object.assign(alimentosProcess[index].nutrientes_raw, el.nutrientes_raw)
      Object.assign(alimentosProcess[index].nutrientes, el.nutrientes)
      Object.assign(alimentosProcess[index].nutrientes_originais, el.nutrientes)
    })

    if (alimentosStored === null || alimentosStored === {}) {
      alimentosStored = {}
      for (let al in alimentosProcess) {
        alimentosStored[alimentosProcess[al].id] = alimentosProcess[al]
      }
      alimentosStored[ID_LEITE_VACA] = state.app.leiteDeVaca
      localStorage.setItem('alimentosStored', JSON.stringify(alimentosStored))
    }
    let idsTiposOrdernado = [6, 1, 7, 3, 2, 4, 8]
    let categorias = []
    let tiposKey = {}
    tipos.forEach(el => {
      tiposKey[el.id] = el
    })
    let i = 0
    for (let idTipo in idsTiposOrdernado) {
      if ([9, 5].includes(idTipo)) continue
      idTipo = idsTiposOrdernado[idTipo]
      let el = tiposKey[idTipo]
      el.nome = el.nome === null ? '' : el.nome
      el.nome_espanhol = el.nome_espanhol === null ? '' : el.nome_espanhol
      el.nome_ingles = el.nome_ingles === null ? '' : el.nome_ingles
      categorias.push({
        id: el['id'],
        idOrd: i,
        name: el['nome'].toUpperCase(),
        name_en: el['nome_ingles'].toUpperCase(),
        name_es: el['nome_espanhol'].toUpperCase(),
        derivados: alimentosProcess.filter(elem => ((el.id === 8) || el.id !== 8) && elem.tipo === el['id']).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0)
      })
      i++
      // delete tiposKey[idTipo]
    }
    // se sobrar alguma categoria extra
    /* for (let idTipo in tiposKey) {
      let el = tiposKey[idTipo]
      categorias.push({
        id: el['id'],
        name: el['nome'].toUpperCase(),
        name_en: el['nome_ingles'].toUpperCase(),
        derivados: alimentosProcess.filter(elem => elem.id !== '2027-53|0|0.5' && elem.tipo === el['id']).sort((a, b) => replaceSpecialChars(a.name) < replaceSpecialChars(b.name) ? -1 : replaceSpecialChars(a.name) > replaceSpecialChars(b.name) ? 1 : 0)
      })
    } */
    state.app.categorias_alimentos = categorias
  },
  setAlimentosSelecionados: (state, newValue) => {
    if (newValue !== null && newValue.length > 0) {
      state.app.alimentos_selecionados = Array.from(newValue.filter(el => !el.derivados))
    } else if (newValue !== null && typeof newValue === 'object') {
      state.app.alimentos_selecionados = Object.values(newValue)
    } else if (newValue !== null) {
      state.app.alimentos_selecionados = newValue
    } else {
      return
    }
    let idsTiposOrdernado = [6, 1, 7, 3, 2, 9, 4, 8, 5]
    let alimentosSelecionados = []
    if (state.app.alimentos_selecionados === null || state.app.alimentos_selecionados.length === 0) return
    for (let idTipo of idsTiposOrdernado) {
      state.app.alimentos_selecionados
        .filter(al => al.tipo === idTipo)
        .forEach((al) => {
          alimentosSelecionados.push(al)
        })
    }
    state.app.alimentos_selecionados = alimentosSelecionados
    let leite = state.app.leiteDeVaca
    if (leite.minimo !== null) { leite.minimo = (state.app.idioma === 0) ? leite.minimo.replace('.', ',') : leite.minimo }
    if (leite.maximo !== null) { leite.maximo = (state.app.idioma === 0) ? leite.maximo.replace('.', ',') : leite.maximo }
    if (state.app.animal.tipo.valor === BEZERRO) state.app.alimentos_selecionados.unshift(leite)
    state.app.alimentos_checked_mobile = state.app.alimentos_selecionados.map((al) => al.id)
    state.app.restricoes_mobile = {}
    state.app.alimentos_selecionados.forEach((al) => {
      state.app.restricoes_mobile[al.id] = {
        custo: al.custo,
        quantidade: al.quantidade,
        min: al.minimo,
        max: al.maximo
      }
    })
  },
  setAlimentoAlterado: (state, index) => {
    state.app.alimentos_selecionados[index].alterado = true
  },
  setComposicaoDieta: (state, newValue) => {
    state.app.composicao_dieta = newValue
    for (let d in newValue) {
      if (!state.app.composicao_dieta_mobile[d]) continue
      state.app.composicao_dieta_mobile[d]['alimentos'] = {}
      state.app.composicao_dieta_mobile[d]['minimo'] = (state.app.exigencias[d] === undefined) ? 0.00 : isNaN(state.app.exigencias[d]['minimo_raw']) ? state.app.exigencias[d]['minimo'] : state.app.exigencias[d]['minimo_raw']
      state.app.composicao_dieta_mobile[d]['ideal'] = (state.app.exigencias[d] === undefined) ? 0.00 : isNaN(state.app.exigencias[d]['ideal_raw']) ? state.app.exigencias[d]['ideal'] : state.app.exigencias[d]['ideal_raw']
      state.app.composicao_dieta_mobile[d]['maximo'] = (state.app.exigencias[d] === undefined) ? 0.00 : isNaN(state.app.exigencias[d]['maximo_raw']) ? state.app.exigencias[d]['maximo'] : state.app.exigencias[d]['maximo_raw']
      for (let al in newValue[d]['alimentos']) {
        if (al === 'ID_LEITE_VACA') al = ID_LEITE_VACA
        state.app.composicao_dieta_mobile[d].alimentos[state.app.alimentos_selecionados[state.app.alimentos_selecionados.findIndex(a => a.id === al)].name] = state.app.composicao_dieta[d].alimentos[(al === ID_LEITE_VACA) ? 'ID_LEITE_VACA' : al]
      }
    }
  },
  setComposicaoRacao: (state, newValue) => {
    state.app.composicao_racao = newValue
    for (let item in newValue) {
      if (state.app.composicao_racao_mobile[item] === undefined) continue
      state.app.composicao_racao_mobile[item].total = newValue[item].total
      if (state.app.composicao_racao_mobile[item].moeda) {
        state.app.composicao_racao_mobile[item].moeda = newValue[item].unidadeEsq[state.app.idioma]
      } else if (item === 'proporcaoVC') {
        state.app.composicao_racao_mobile[item].unidade = newValue[item].v + ':' + newValue[item].c
      } else {
        state.app.composicao_racao_mobile[item].unidade = newValue[item].unidadeDir[state.app.idioma]
      }
      for (let al in newValue.alimentos) {
        state.app.composicao_racao_mobile[item][state.app.alimentos_selecionados[state.app.alimentos_selecionados.findIndex(a => a.id === al)].name] = state.app.composicao_racao[item].alimentos[al]
      }
    }
  },
  setExcrecao: (state, newValue) => {
    state.app.excrecao = newValue
    for (let d in newValue) {
      state.app.excrecao_mobile[d] = newValue[d].valor
    }
  },
  setLeiteDeVaca: (state) => {
    state.app.leiteDeVaca.restrito = true
    if (state.app.animal.tipo.valor === BEZERRO && parseString(state.app.animal.producao_de_leite.valor, state.app.idioma) > 0) {
      let SL = parseString(state.app.animal.semana_lactacao.valor, state.app.idioma)
      if (SL === 0 || isNaN(SL)) {
        SL = 1
      }
      let PLe = parseString(state.app.animal.producao_de_leite.valor, state.app.idioma)
      if (PLe === 0 || isNaN(PLe)) {
        let result = 8.819 - 0.069 * SL - 8.819 * Math.exp(-3.211 * SL)
        switch (state.app.animal.estado_parides.valor) {
            case PRIMIPARAS:
              result = (
                6.431 -
                0.072 * SL -
                6.431 * Math.exp(-2.188 * SL)
              )
            break;
            case MULTIPARAS:
              result = (
                7.996 -
                0.101 * SL -
                7.996 * Math.exp(-1.447 * SL)
              )
        }
        PLe = result
      }
      const MS = state.app.leiteDeVaca.nutrientes['MS']
      state.app.leiteDeVaca.minimo = state.app.leiteDeVaca.maximo = (PLe / (1 / (MS / 100))).toFixed(2).replace('.', state.app.strings[state.app.idioma].separador_float)
      state.app.leiteDeVaca.minimo_raw = state.app.leiteDeVaca.maximo_raw = (PLe / (1 / (MS / 100)))
      // (8.819 - 0.069 * parseString(state.app.animal.semana_lactacao.valor, state.app.idioma) - 8.819 * Math.exp(-3.211 * parseString(state.app.animal.semana_lactacao.valor, state.app.idioma))).toFixed(2)
    } else if (state.app.animal.tipo.valor === BEZERRO) {
      state.app.leiteDeVaca.minimo = state.app.leiteDeVaca.maximo = (0).toFixed(2).replace('.', state.app.strings[state.app.idioma].separador_float)
      state.app.leiteDeVaca.minimo_raw = state.app.leiteDeVaca.maximo_raw = (0)
    }
  },
  setMinMaxExigencias (state, { index, exigenciasAntigas }) {
    let proporcaoMin = 1 - (exigenciasAntigas[index].minimo_calc / exigenciasAntigas[index].ideal_calc)
    let proporcaoMax = 1 - (exigenciasAntigas[index].ideal_calc / exigenciasAntigas[index].maximo_calc)
    if (exigenciasAntigas[index].minimo_calc === exigenciasAntigas[index].ideal_calc && exigenciasAntigas[index].minimo_calc === 0) {
      proporcaoMin = 0
    }
    let newMin = parseString(state.app.exigencias[index].ideal, state.app.idioma) - (parseString(state.app.exigencias[index].ideal, state.app.idioma) * proporcaoMin)
    let newMax = parseString(state.app.exigencias[index].ideal, state.app.idioma) + (parseString(state.app.exigencias[index].ideal, state.app.idioma) * proporcaoMax)
    newMin = (parseString(state.app.exigencias[index].ideal, state.app.idioma) === 0) ? exigenciasAntigas[index].minimo_calc : parseString(state.app.exigencias[index].ideal, state.app.idioma)

    if (newMax === 0 && exigenciasAntigas[index].minimo_calc === exigenciasAntigas[index].ideal_calc && exigenciasAntigas[index].minimo_calc === 0) {
      newMax = exigenciasAntigas[index].maximo_calc
    }
    if (exigenciasAntigas[index].minimo_calc > exigenciasAntigas[index].ideal_calc) {
      newMin = (parseString(state.app.exigencias[index].ideal, state.app.idioma) === 0) ? exigenciasAntigas[index].minimo_calc : parseString(state.app.exigencias[index].ideal, state.app.idioma)
      newMax = (parseString(state.app.exigencias[index].ideal, state.app.idioma) === 0) ? exigenciasAntigas[index].maximo_calc : parseString(state.app.exigencias[index].ideal, state.app.idioma)
    }
    state.app.exigencias[index].minimo_raw = (newMin > 0) ? newMin : 0
    state.app.exigencias[index].maximo_raw = (newMax > 0) ? newMax : 0
    state.app.exigencias[index].maximo = ((newMax > 0) ? newMax : 0).toFixed(2)
    state.app.exigencias[index].minimo = ((newMin > 0) ? newMin : 0).toFixed(2)
    if (['PDR', 'PNDR', 'PB'].includes(index)) {
      let i = 0
      let nc = null
      for (let ex of ['PNDR', 'PDR', 'PB']) {
        i += state.app.exigencias[ex].changed ? 1 : 0
        if (!state.app.exigencias[ex].changed && ex !== index) {
          nc = ex
        }
      }
      if (i >= 1) {
        switch (nc) {
          case 'PB':
            state.app.exigencias[nc].ideal_raw = state.app.exigencias['PDR'].ideal_raw + state.app.exigencias['PNDR'].ideal_raw
            state.app.exigencias[nc].minimo_raw = state.app.exigencias['PDR'].minimo_raw + state.app.exigencias['PNDR'].minimo_raw
            state.app.exigencias[nc].maximo_raw = state.app.exigencias['PDR'].maximo_raw + state.app.exigencias['PNDR'].maximo_raw
            break
          case 'PDR':
            state.app.exigencias[nc].ideal_raw = state.app.exigencias['PB'].ideal_raw - state.app.exigencias['PNDR'].ideal_raw
            state.app.exigencias[nc].minimo_raw = state.app.exigencias['PB'].minimo_raw - state.app.exigencias['PNDR'].minimo_raw
            state.app.exigencias[nc].maximo_raw = state.app.exigencias['PB'].maximo_raw - state.app.exigencias['PNDR'].maximo_raw
            break
          case 'PNDR':
            state.app.exigencias[nc].ideal_raw = state.app.exigencias['PB'].ideal_raw - state.app.exigencias['PDR'].ideal_raw
            state.app.exigencias[nc].minimo_raw = state.app.exigencias['PB'].minimo_raw - state.app.exigencias['PDR'].minimo_raw
            state.app.exigencias[nc].maximo_raw = state.app.exigencias['PB'].maximo_raw - state.app.exigencias['PDR'].maximo_raw
            break
        }
        state.app.exigencias[nc].ideal = ((state.app.exigencias[nc].ideal_raw > 0) ? state.app.exigencias[nc].ideal_raw : 0).toFixed(2)
        state.app.exigencias[nc].maximo = ((state.app.exigencias[nc].maximo_raw > 0) ? state.app.exigencias[nc].maximo_raw : 0).toFixed(2)
        state.app.exigencias[nc].minimo = ((state.app.exigencias[nc].minimo_raw > 0) ? state.app.exigencias[nc].minimo_raw : 0).toFixed(2)
      }
    }
  },
  setMinExigencias (state, index) {
    let resposta = 0.00
    let idioma = state.app.idioma
    let max = parseString(state.app.exigencias[index].maximo, idioma)
    let ideal = parseString(state.app.exigencias[index].ideal, idioma)
    let min = parseString(state.app.exigencias[index].minimo, idioma)
    if ((ideal !== 0 || !isNaN(ideal)) && (min > ideal)) { resposta = ideal } else if ((ideal === 0 || isNaN(ideal)) && (min > max)) { resposta = max } else if (min !== 0 || !isNaN(min)) { resposta = min }
    let resStr = (resposta === 0.00) ? '-' : resposta.toFixed(2)
    state.app.exigencias[index].minimo = resStr
  },
  setMaxExigencias (state, index) {
    let resposta = 0.00
    let idioma = state.app.idioma
    let max = parseString(state.app.exigencias[index].maximo, idioma)
    let ideal = parseString(state.app.exigencias[index].ideal, idioma)
    let min = parseString(state.app.exigencias[index].minimo, idioma)
    if ((ideal !== 0 || !isNaN(ideal)) && (max < ideal)) { resposta = ideal } else if ((ideal === 0 || isNaN(ideal)) && (max < min)) { resposta = min } else if (min !== 0 || !isNaN(min)) { resposta = max }
    let resStr = (resposta === 0.00) ? '-' : resposta.toFixed(2)
    state.app.exigencias[index].maximo = resStr
  },
  setRelatorioFinanceiro (state, newValue) {
    state.app.relatorio_financeiro = newValue
    let idioma = state.app.idioma
    for (let tipoRel in newValue) {
      for (let item in state.app.relatorio_financeiro_mobile[tipoRel]) {
        if (!newValue[tipoRel][item] || !newValue[tipoRel][item]['valor']) continue
        state.app.relatorio_financeiro_mobile[tipoRel][item]['value'] = (newValue[tipoRel][item]['valor'] === null) ? null : parseString(newValue[tipoRel][item]['valor'], idioma)
      }
    }
  },
  setRelatorioFinanceiroCenarios: (state, cenarios) => {
    state.app.relatorio_financeiro_cenarios = cenarios
  },
  convertAnimal (state, animalMobile) {
    let animal = new Animal(state)
    let tiposNumber = [0, 3, 4, 5, 6, 7, 8]
    for (let tipo in animalMobile) {
      if (state.app.animal && state.app.animal[tipo] && tiposNumber.includes(state.app.animal[tipo].tipo) && !isNaN(parseFloat(animalMobile[tipo]))) {
        animal[tipo] = parseFloat(animalMobile[tipo])
      } else {
        animal[tipo] = animalMobile[tipo]
      }
    }
    state.app.animal = animal.getData()
    state.app.animal_ = animal
    state.app.animal_mobile = animalMobile
  },
  convertComposicaoDieta (state, dietaMobile) {
    let exigenciasResultado = state.app.exigencias_resultados
    state.app.composicao_dieta = {}
    state.app.composicao_dieta_mobile = Object.assign({}, dietaMobile)
    let composicaoDieta = state.app.composicao_dieta
    let animal = state.app.animal
    let idioma = state.app.idioma
    let cmsTotal = 0
    for (let d in dietaMobile) {
      let exigencia = d
      state.app.composicao_dieta[d] = {}
      state.app.exigencias[d]['minimo'] = state.app.exigencias[d]['minimo_raw'] = state.app.exigencias[d]['minimo_calc'] = state.app.composicao_dieta_mobile[d]['minimo']
      state.app.exigencias[d]['maximo'] = state.app.exigencias[d]['maximo_raw'] = state.app.exigencias[d]['maximo_calc'] = state.app.composicao_dieta_mobile[d]['maximo']
      state.app.exigencias[d]['ideal'] = state.app.exigencias[d]['ideal_raw'] = state.app.exigencias[d]['ideal_calc'] = state.app.composicao_dieta_mobile[d]['ideal']
      state.app.composicao_dieta[d]['alimentos'] = {}
      let total = 0
      for (let al in dietaMobile[d]['alimentos']) {
        let alid = null
        if (al.toUpperCase() === 'LEITE DE VACA') alid = ID_LEITE_VACA
        else alid = state.app.alimentos_selecionados.findIndex(a => a.name === al)
        state.app.composicao_dieta[d]['alimentos'][alid] = {}
        state.app.composicao_dieta[d]['alimentos'][alid]['id'] = alid
        state.app.composicao_dieta[d]['alimentos'][alid]['valor'] = state.app.composicao_dieta_mobile[d].alimentos[al]
        state.app.composicao_dieta[d]['alimentos'][alid]['valorUnidade'] = state.app.composicao_dieta_mobile[d].alimentos[al]
        state.app.composicao_dieta[d]['alimentos'][alid]['unidade'] = state.app.exigencias[d]['unidade']
        total += state.app.composicao_dieta[d]['alimentos'][alid]['valor']
      }
      state.app.composicao_dieta[d]['id'] = d
      state.app.composicao_dieta[d]['total'] = total
      if (exigenciasResultado[exigencia].unidade[0] === 'g/dia' || exigenciasResultado[exigencia].unidade[0] === 'Mcal/dia') {
        total /= 1000
      } else if (exigenciasResultado[exigencia].unidade[0] === 'mg/dia') {
        total /= 10 * 1000
      }
      if (exigencia === 'CMS') cmsTotal = total
      composicaoDieta[exigencia].cms_pv = (exigencia === 'CMS') ? (total / parseString(animal.peso_corporal_medio.valor, idioma)) * 100 : 0
      composicaoDieta[exigencia].pcms = (exigencia === 'CMS' || exigencia === 'EL' || exigencia === 'EM') ? 0 : ((total / d) * 100)
      composicaoDieta[exigencia].mcal = (exigencia === 'EL' || exigencia === 'EM') ? (total / cmsTotal) * 1000 : 0
      composicaoDieta[exigencia].mg = (exigenciasResultado[exigencia].micromineral) ? (exigenciasResultado[exigencia].unidade[0] === 'mg/dia') ? composicaoDieta[exigencia].total / cmsTotal : (total / cmsTotal) * 100 : 0
    }
  },
  convertComposicaoRacao (state, racaoMobile) {
    state.app.composicao_racao_mobile = Object.assign(racaoMobile)
    for (let item in racaoMobile) {
      if (state.app.composicao_racao_mobile[item] === undefined) continue
      state.app.composicao_racao_mobile[item].total = racaoMobile[item].total
      if (item === 'proporcaoVC') {
        state.app.composicao_racao[item].v = parseInt(state.app.composicao_racao_mobile[item].unidade.split(':')[0])
        state.app.composicao_racao[item].c = 100 - state.app.composicao_racao[item].v
      } else {
        state.app.composicao_racao[item].unidade[state.app.idioma] = state.app.composicao_racao_mobile[item].unidadeDir[state.app.idioma]
      }
      for (let al in racaoMobile[item].alimentos) {
        let alid = null
        if (al.toUpperCase() === 'LEITE DE VACA') alid = ID_LEITE_VACA
        else alid = state.app.alimentos_selecionados.findIndex(a => a.name === al)
        state.app.composicao_racao[item].alimentos[alid] = state.app.composicao_racao_mobile[item].alimentos[al]
      }
    }
  },
  setDietaCalculada (state, newValue) {
    state.app.dieta_calculada = newValue
  },
  setAlert (state, newValue) {
    state.app.alert = newValue
  },
  setModal (state, newValue) {
    state.app.modal = newValue
  },
  openOKModal (state, { title, msg, error = false, responseCallback = null }) {
    state.app.modal.optionsType = 'OK'
    state.app.modal.title = title
    state.app.modal.msg = msg
    state.app.modal.error = error
    state.app.modal.responseCallback = responseCallback
    state.app.modal.active = true
  },
  openErrorAlert (state, { msg, time }) {
    state.app.alert.msg = msg
    state.app.alert.ativo = true
    state.app.alert.msg_type = 'error'
    state.app.alert.time = time
    if (time > 0) { setTimeout(() => { state.app.alert.ativo = false }, time) }
  },
  openSuccessAlert (state, { msg, time }) {
    state.app.alert.msg = msg
    state.app.alert.ativo = true
    state.app.alert.msg_type = 'success'
    state.app.alert.time = time
    if (time > 0) { setTimeout(() => { state.app.alert.ativo = false }, time) }
  },
  openWarningAlert (state, { msg, time }) {
    state.app.alert.msg = msg
    state.app.alert.ativo = true
    state.app.alert.msg_type = 'success'
    state.app.alert.time = time
    if (time > 0) { setTimeout(() => { state.app.alert.ativo = false }, time) }
  },
  setDietasServer (state, val) {
    let dietas = JSON.parse(val)
    state.app.dietas = dietas
  },
  getDietas (state) {
    let dietas = JSON.parse(localStorage.getItem('dietas_'))
    state.app.dietas = dietas
  },
  getPredicoes (state) {
    let dietas = JSON.parse(localStorage.getItem('predicoes_'))
    state.app.predicoes = dietas
  },
  getTabelasSalvas (state) {
    let dietas = JSON.parse(localStorage.getItem('tabelas_'))
    state.app.tabelas = dietas
  },
  loadPredicao (state, dieta) {
    localStorage.setItem('predicao', JSON.stringify(dieta))
  },
  loadDieta () {
    localStorage.removeItem('dieta')
  },
  loadTabela (state, name) {
    let dietas = JSON.parse(localStorage.getItem('tabelas_'))
    let dieta = dietas.find(n => n.name === name)
    localStorage.setItem('tabela', JSON.stringify(dieta))
  },
  removeDieta (state, dieta) {
    let dietas = JSON.parse(localStorage.getItem('dietas_'))
    dietas = dietas.filter(d => d.name !== dieta.name)
    state.app.dietas = dietas
    localStorage.setItem('dietas_', JSON.stringify(dietas))
  },
  removePredicao (state, dieta) {
    let dietas = JSON.parse(localStorage.getItem('predicoes_'))
    dietas = dietas.filter(d => d.name !== dieta.name)
    state.app.predicoes = dietas
    localStorage.setItem('predicoes_', JSON.stringify(dietas))
  },
  removeTabela (state, dieta) {
    let dietas = JSON.parse(localStorage.getItem('tabelas_'))
    dietas = dietas.filter(d => d.name !== dieta.name)
    state.app.tabelas = dietas
    localStorage.setItem('tabelas_', JSON.stringify(dietas))
  },
  saveDieta_ (state, name) {
    let dietas = JSON.parse(localStorage.getItem('dietas'))
    if (dietas === null) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.name === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = {
      id: name,
      time: new Date().getTime(),
      animal: state.app.animal_mobile,
      alimentos: {
        alimentos_checked: state.app.alimentos_checked_mobile,
        restricoes: state.app.restricoes_mobile
      },
      exigencias: {
        lista_exigencias_selecionadas: state.app.exigencias_selecionadas
      },
      dieta: {
        composicao_dieta: state.app.composicao_dieta_mobile,
        composicao_racao: state.app.composicao_racao_mobile,
        relatorio_financeiro: state.app.relatorio_financeiro_mobile,
        excrecao: state.app.excrecao_mobile,
        dados_predicao: state.app.dados_predicao_mobile,
        fixaProporcaoVC: state.app.fixavc,
        proporcaoVolumoso: state.app.composicao_racao.proporcaoVC.v
      }
    }
    dietas.push({ time: new Date().getTime(), name: name, animal: state.app.animal, exigencias: state.app.exigencias, exigencias_selecionadas: state.app.exigencias_selecionadas, alimentos_selecionados: state.app.alimentos_selecionados, composicao_dieta: state.app.composicao_dieta, composicao_racao: state.app.composicao_racao, excrecao: state.app.excrecao, relatorio_financeiro: state.app.relatorio_financeiro, user_id: state.app.user.id })
    // dietas.push({'id': dietas.length ,'dieta':dieta})
    localStorage.setItem('dietas', JSON.stringify(dietas))
  },
  saveDieta (state, name) {
    let dietas = JSON.parse(localStorage.getItem('dietas_'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.name === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = {}
    // crfia objeto para animal;
    let animal = state.app.animal_.getMobileData()
    let resultado = {}
    for (let id in state.app.composicao_racao['MN'].alimentos) {
      resultado[id] = state.app.composicao_racao['MN'].alimentos[id].valor
    }
    let exigenciasSelecionadas = Array.from(state.app.exigencias_selecionadas)
    let exigenciasAlteradas = {}
    for (let exigencia in state.app.exigencias) {
      if (state.app.exigencias[exigencia].changed) exigenciasAlteradas[exigencia] = state.app.exigencias[exigencia].ideal_raw
    }
    let restricoes = {}
    let alsel = Object.assign({}, state.app.alimentos_selecionados)
    for (let a of Object.values(alsel)) {
      a.minimo = (a.minimo !== null && typeof a.minimo === 'string' && a.minimo.trim() !== '') ? parseString(a.minimo, state.app.idioma) : null
      a.maximo = (a.maximo !== null && typeof a.maximo === 'string' && a.maximo.trim() !== '') ? parseString(a.maximo, state.app.idioma) : null
      a.custo = (a.custo !== null && typeof a.custo === 'string' && a.custo.trim() !== '') ? parseString(a.custo, state.app.idioma) : null
      restricoes[a.id] = ((!a.alterado) ? { minimo: a.minimo, maximo: a.maximo, custo: a.custo } : { minimo: a.minimo, maximo: a.maximo, custo: a.custo, nutrientes: a.nutrientes })
    }
    let vc = (state.app.fixavc) ? { v: state.app.composicao_racao['proporcaoVC'].v, c: state.app.composicao_racao['proporcaoVC'].c } : null

    dieta = { name: name, time: new Date().getTime(), animal, restricoes, resultado, vc, 'exigencias_selecionadas': exigenciasSelecionadas, 'exigencias_alteradas': exigenciasAlteradas, 'user_id': state.app.user.id }
    dietas.push(dieta)

    localStorage.setItem('dietas_', JSON.stringify(dietas))
  },
  savePredicao_ (state, name) {
    let dietas = JSON.parse(localStorage.getItem('predicoes'))
    let dietasSimples = JSON.parse(localStorage.getItem('predicoes'))
    if (dietas === null) {
      dietas = []
      dietasSimples = []
    }
    let dietasEncontradas = dietas.find(n => n.name === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = {
      id: name,
      time: new Date().getTime(),
      animal: state.app.animal_mobile,
      alimentos: {
        alimentos_checked: state.app.alimentos_checked_mobile,
        restricoes: state.app.restricoes_mobile
      },
      exigencias: {
        lista_exigencias_selecionadas: state.app.exigencias_selecionadas
      },
      dieta: {
        composicao_dieta: state.app.composicao_dieta_mobile,
        composicao_racao: state.app.composicao_racao_mobile,
        relatorio_financeiro: state.app.relatorio_financeiro_mobile,
        excrecao: state.app.excrecao_mobile,
        dados_predicao: state.app.dados_predicao_mobile,
        fixaProporcaoVC: state.app.fixavc,
        proporcaoVolumoso: state.app.composicao_racao.proporcaoVC.v,
        tipo_alimento_predicao: state.app.tipo_alimento_predicao
      }
    }
    dietasSimples.push({ 'id': dietas.length, 'dieta': dieta })
    dietas.push({ time: new Date().getTime(), name: name, animal: state.app.animal, exigencias: state.app.exigencias, exigencias_selecionadas: state.app.exigencias_selecionadas, alimentos_selecionados: state.app.alimentos_selecionados, composicao_dieta: state.app.composicao_dieta, composicao_racao: state.app.composicao_racao, dados_predicao: state.app.dados_predicao, tipo_alimento_predicao: state.app.tipo_alimento_predicao, excrecao: state.app.excrecao, user_id: state.app.user.id })

    localStorage.setItem('predicoes', JSON.stringify(dietas))
  },
  savePredicao (state, name) {
    let dietas = JSON.parse(localStorage.getItem('predicoes_'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.name === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    let dieta = {}
    // crfia objeto para animal;
    let animal = state.app.animal_.getMobileData()
    let resultado = {}
    for (let id in state.app.composicao_racao['MN'].alimentos) {
      resultado[id] = state.app.composicao_racao['MN'].alimentos[id].valor
    }
    let exigenciasSelecionadas = Array.from(state.app.exigencias_selecionadas)
    let exigenciasAlteradas = {}
    for (let exigencia in state.app.exigencias) {
      if (state.app.exigencias[exigencia].changed) exigenciasAlteradas[exigencia] = state.app.exigencias[exigencia].ideal_raw
    }
    let restricoes = {}
    for (let a of state.app.alimentos_selecionados) {
      let fator = 1
      switch (a.unidade) {
        case 'kg':
          fator = 1
          break
        case 'g':
          fator = 1000
          break
        case 'mg':
          fator = 1000000
          break
        default:
          fator = 1
      }
      a.quantidade = (a.quantidade !== null && typeof a.quantidade === 'string' && a.quantidade.trim() !== '') ? parseString(a.quantidade, state.app.idioma) / fator : null
      restricoes[a.id] = ((!a.alterado) ? { quantidade: a.quantidade } : { quantidade: a.quantidade, nutrientes: a.nutrientes })
    }
    dieta = { name: name, time: new Date().getTime(), animal, restricoes, resultado, tipo_alimento_predicao: state.app.tipo_alimento_predicao, 'exigencias_selecionadas': exigenciasSelecionadas, 'exigencias_alteradas': exigenciasAlteradas, 'user_id': state.app.user.id }
    dietas.push(dieta)

    localStorage.setItem('predicoes_', JSON.stringify(dietas))
  },
  saveTabela (state, name) {
    let dietas = JSON.parse(localStorage.getItem('tabelas_'))
    if (dietas === null || Object.keys(dietas).length === 0) {
      dietas = []
    }
    let dietasEncontradas = dietas.find(n => n.name === name)
    if (dietasEncontradas !== undefined) {
      name += new Date().getTime()
    }
    dietas.push({ time: new Date().getTime(), name: name, alimentos_selecionados: state.app.alimentos_selecionados, user_id: state.app.user.id })

    localStorage.setItem('tabelas_', JSON.stringify(dietas))
  }
}
